import { Component, EventEmitter, OnInit, Output, ViewChild, Input, ElementRef, AfterViewInit, OnDestroy} from '@angular/core';
import {PdfRenditionWatcher} from '../../shared/pdf-rendition-watcher';
import {IdexService} from '../../idex.service';
import {Subject, Observable, throwError} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {Toast} from '../../shared/toast/toast';
import {LeftPanelComponent} from './left-panel/left-panel.component';
import {RegisterSignatureComponent} from '../register-signature/register-signature.component';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {ViewDocumentComponent} from './view-document/view-document.component';
import {TranslateService} from '@ngx-translate/core';
import {TwofactorComponent} from '../../account/twofactor/twofactor.component';
import {SetpasswordDialogComponent} from '../setpassword-dialog/setpassword-dialog.component';
import { DatePipe } from '@angular/common';
import { Form, TaskAttribute } from '../create-task/create-task.type';

declare let $: any;
declare let SVG: any;
declare let moment: any;
// declare const SVG:any;
let changeImage;
let onDrag;
let typeName;
const widthInit = 100;
const widthInitInit = 80;
const heightInit = 50;
const heightInitInit = 40;
const widthAttachInit = 120;
const heightAttachInit = 60;
declare let EnjoyHint: any;
let enjoyhint_instance: any;

@Component({
   selector: 'app-sign-off',
   templateUrl: './sign-off.component.html',
   styleUrls: ['./sign-off.component.css', '../../../assets/font_stylesheet.css']
})
export class SignOffComponent implements OnInit, AfterViewInit, OnDestroy {
   @Input() typeName: string;
   @Input() taskAttribute: TaskAttribute;
   @Input() docId: any;
   @Input() isToggleRightOpened: any;
   @Input() tempId: any;
   @Input() isShow = false;
   @Input() taskStatus: string;
   @Output() onscrollTum = new EventEmitter<any>();
   @Output() docName = new EventEmitter<any>();
   @Output() actionLoad = new EventEmitter<any>();
   @Output() toggleRight = new EventEmitter<any>();
   @Output() listClickEvent = new EventEmitter<any>();
   @ViewChild('print') print: ElementRef;
   @ViewChild('drawer') drawer;
   @ViewChild('mainDrawer') mainDrawer;
   @ViewChild('btnAction') btnAction;
   @ViewChild('btnToggleNav') btnToggleNav;
   @ViewChild('groupPageTrans') groupPageTrans: ElementRef;
   @ViewChild('groupAction') groupAction: ElementRef;
   @ViewChild('allImages') allImages: ElementRef;
   @ViewChild('sideNavContent') sideNavContent: ElementRef;
   @ViewChild(LeftPanelComponent) leftPanelComp: LeftPanelComponent;
   @ViewChild(ViewDocumentComponent) viewDocumentComp: ViewDocumentComponent;
   @ViewChild('canvasOriginal', { static: true }) public canvasOriginal: ElementRef;
   @ViewChild('canvasPatternTmp', { static: true }) public canvasPatternTmp: ElementRef;

   STATUS_2FA = 591;
   item: any;
   pageNo1 = 1;
   numprint: any;
   type: any;
   timeout = 0;
   mytime: any;
   numIndex = 0;
   mimType: any;
   errorMessage: string;
   isClickPage = false;
   isLoopPage = false;
   urlPrevPage: any;
   checkheightpage: any = 0;
   page = 1;
   checkpositionpage = true;
   position = 0;
   private _hasSignature;
   private _hasInitial;
   signatureId: string;
   initialId: string;
   public zoomRatio = 1.0;
   public _docList = [];
   public _signObjects = [];
   public _totalPages;
   public _docListItem;
   public signMenuClick;
   public signMenuDrag;
   public signActionClick;
   public saveActionClick;
   public sendActionClick;
   public isHideAction = false; // set for hide when waiting for other
   public isHideArrowLeft = false;
   public isHideArrowRight = true;
   public isHideCommentPdf = false;
   public isInitail = false;
   public isDrawing = false;
   public startDrawing = false;
   public images;
   public picAttachImg
   public picCheckBox;
   public picSign;
   public picInitSign;
   public imgUrl: any;
   public maxWidth = 0;
   public maxHeight = 0;
   public width = 384;
   public height = 594;
   public currentIndex = 0;
   public signerSelected;
   public pageType = 'CP';
   public positionType = 'CT';
   public chkName: boolean;
   public chkDate: boolean;
   public chkApplyAll: boolean;
   public isHideDeleteBtn = false;
   public isHideRequire = true;
   public isHideProperties = false;
   public currentPageNo; // TODO : change when docList Click
   public widthSignItem;
   public heightSignItem;
   public transformHeight;
   public isHideViewDocument = true;
   public watermark: any;
   public colors = [
      '#8b0000',
      '#daa520',
      '#778899',
      '#800080',
      '#ff00ff',
      '#008080',
      '#556b2f',
      '#32cd32',
      '#3EA99F',
      '#0000cd',
      '#ff69b4',
      '#ff0000',
      '#bdb76b',
      '#FFD700',
      '#7FFFD4',
      '#FF4500',
      '#32CD32',
      '#FF8B8B',
      '#9932CC',
      '#A0522D',
      '#00CED1',
      '#2F4F4F',
      '#98AFC7',
      '#566D7E',
      '#FBE7A1',
      '#728FCE',
      '#4863A0',
      '#2B547E',
      '#81D8D0',
      '#2554C7',
      '#1589FF',
      '#00BFFF',
      '#87CEEB',
      '#C6DEFF',
      '#B0E0E6',
      '#16E2F5',
      '#045F5F',
      '#31906E',
      '#50C878',
      '#006400',
      '#32CD32',
      '#DAEE01',
      '#FFFACD',
      '#57FEFF',
      '#FED8B1',
      '#FFFF00',
      '#D9F1F1',
      '#B6E3E9',
      '#D1EAF5',
      '#C3DDE0',
      '#A5CEDB',
      '#95C8D7',
      '#AACCE2',
      '#789CCE',
      '#FBD4AD',
      '#F8D7C1',
      '#EDAB94',
      '#FFAE92',
      '#DADDC5',
      '#A5B89C',
      '#C1D7D0',
      '#CAE3CC',
      '#E0F8E8',
      '#D9EDE7',
      '#BDDED1',
      '#B7B7FF',
      '#E7D2EF',
      '#EFE5EE',
      '#C4B3C3',
      '#C6A5C7',
      '#E2D0DC',
      '#D9B0CD',
      '#DFA5D6',
      '#E5A9DE',
      '#FEF4F3',
      '#FCDEE2',
      '#FFD6DA',
      '#FFC6CF',
      '#FFE4E3',
      '#FFD3D3',
      '#FFCDCD',
      '#FFB7B7',
      '#FBF1D5',
      '#FFE2AE',
      '#F4CC84',
      '#F7D07A'
   ];
   public fontDetail = {
      'fontStyle': 'THSarabunNew',
      'fontSize': 9,
      'fontColor': '#000000',
      'fontBold': false,
      'fontItalic': false,
      'fontUnderline': false,
      'textRequired': false
   }
   public isZoom = false;
   public isFitPage = false;
   public hasSignature;
   public hasInitial;
   private giveScroll = 0;
   private _marginn = 30;
   private _isHideProp = false;
   private _pageCount = 1;
   private _isDeselect = true;
   private _isChangeSigner = false;
   private _giveNullElement;
   private _objectSVG = [];
   private _docIds = [];
   private _signItem;
   private _user = this.service.user;
   private _password;
   private _margin = 30;
   private _draw;
   private _objDraw;
   public _isVisible;
   private _imgFocus: any;
   private _widthInit = 100;
   private _widthInitName = 49;
   private _widthInitDate = 54;
   private _heightInit = 50;
   private _heightInitNameDate = 9;
   private _widthSignature = 30;
   private _widthInitSignature = 18;
   private _widthInitAttach = 120;
   private _heightInitAttach = 60;
   private _widthInitCheckBox = 22.5;
   private _widthInitBox = 13.5;
   private _widthInitCheck = 10;
   private _heightInitCheckBox = 22.5;
   private _heightInitBox = 12;
   private _heightInitCheck = 10;
   private _y = -4;
   private _fontSize = 9;
   private _yMarginSign = 4;
   private _isHaveThai = false;
   private _eventMouseOver;
   private _objectDrag: any;
   private _onDrag;
   private _onClickDelete;
   private _signature = 'Signature';
   private _initialize = 'Initial Sign';
   private _fullName = 'Song Manse';
   private _date = 'DATE';
   private _text = 'TEXT';
   private _image = 'IMAGE';
   private _idSignitems;
   private _heightDialogShowPage = 360;
   private _itemPages;
   public _dataPages;
   renditionWatcher = new PdfRenditionWatcher();
   renditionIndex = 0;

   /** เอกสารที่กำลังแสดงยังแปลงเป็น PDF ไม่เสร็จ */
   get isConverting(): boolean {
      return PdfRenditionWatcher.isConverting(this._dataPages?.[this.renditionIndex]);
   }
   private _statusInitial = [];
   // Attribute Signature Items
   private _signer;
   public _fieldType = 'signature';
   private _pageNum = '1';
   private _moveOnPage = false;
   private _dragIcon;
   private _isDrag = false;
   private _imgFocusCal;
   private _signItems = [];
   private _keyFieldType = {
      signature: 'signature',
      initSignature: 'initSignature',
      name: 'name',
      date: 'date',
      text: 'text',
      image: 'image',
      checkbox: 'checkbox'
   };
   private _flagMouseOver;
   private _fName;
   private _lName;
   private _isTwofacGoogle;
   private _isTwofacSign;
   private _isFirstSingIn = false;
   private countZoom = 0;
   private includeName: any;
   private includeDate: any;
   private chunkSize = 500000;
   private itemImageId;
   ext: any;

   private registerSignDialog: MatDialogRef<RegisterSignatureComponent>;
   private changePasswordDialog: MatDialogRef<SetpasswordDialogComponent>;
   private twofactor: MatDialogRef<TwofactorComponent>;
   public certificateList: any[] = [];
   public tin: string;
   public myFiles = "My Files";
   public siteId: string;
   public certId: string;
   public currentDate: Date;
   public fullName: string  = '';
   certList = ['ZDOX','STCA','ISCA','IDCA']; /// certificate code ZE-1575

   constructor(public service: IdexService,
               private toast: Toast,
               private router: Router,
               private actRoute: ActivatedRoute,
               private dialog: MatDialog,
               private translate: TranslateService) { // TODO : comment for test
      // constructor(public service: IdexService/*,@Inject(MAT_DIALOG_DATA) private data: any */) { // TODO : comment for deploy

      this.signMenuClick = new Subject();
      this.signMenuDrag = new Subject();
      this.signActionClick = new Subject();
      this.saveActionClick = new Subject();
      this.sendActionClick = new Subject();
      this._signer = this._user.email;
      this._isHaveThai = this.checkThaiLanguage(this._user.name);
      this._signItem = {
         'signer': this._signer
         , 'fieldType': this._fieldType
         , 'pageType': this.pageType
         , 'pageNum': this._pageNum
         , 'positionType': this.positionType
         , 'chkName': this.chkName
         , 'chkDate': this.chkDate
         , 'coordinateX': '150'
         , 'coordinateY': '470'
         , 'fieldWidth': this._widthInit
         , 'fieldHeight': this._heightInit
         , 'idSignItem': ''
         , 'flagSign': false
         , 'order': 0
         , 'content': ''
         , 'idImageItem': ''
         , 'fontStyle': 'THSarabunNew'
         , 'fontSize': 9
         , 'fontColor': '#000000'
         , 'fontBold': false
         , 'fontItalic': false
         , 'fontUnderline': false
         , 'textRequired': false
         , 'flagCheckbox': false
         , 'stepOrder': 1
      };
      this._dragIcon = document.createElement('img');
      this._flagMouseOver = false;
      this.isHideCommentPdf = true;
      this.picAttachImg = 'assets/icons/attachImg.png';
      this.picCheckBox = 'assets/icons/tick.png';
      this.currentDate = new Date();
   }

   ngOnInit() {

      const path = localStorage.getItem('url');
      const splitPath = path.split('/', 3);
      if(splitPath[1] === 'files'){
         this.tin = this.myFiles;
      } else {
         this.tin = splitPath[2];
      }

      this.getWatermark();
      this.handleMenuClick();
      this.handleMenuDrag();
      this.handleGetTranslateSignItem();
      this.handleCheckLanguage();
      this.handleToggleClosed();
      typeName = this.typeName;
      this.taskAttribute.docList = [];
      const token = this.service.user.token;
      this.service.getProfile()
         .subscribe((data: any) => {
            this.fullName = data.fName + ' ' + data.lName;
            this._hasSignature = data.hasSignature;
            this._hasInitial = data.hasInitial;
            if (this._hasSignature) {
               this.picSign = this.service.url + '/signature?token=' + token + '&lastmodify=' + Date.now() + '&init=false';
            }
            if (this._hasInitial) {
               this.picInitSign = this.service.url + '/signature?token=' + token + '&lastmodify=' + Date.now() + '&init=true';
            }
            if (this.leftPanelComp) {
               this.leftPanelComp.imageSignatureOriginal = this.picSign;
               this.leftPanelComp.imageInitOriginal = this.picInitSign;
            }
         });

      if (this.tempId) {
         this._docIds.push(this.tempId);
      } else {
         this._docIds.push(this.docId);
      }
      this.handleLoadPage(true);
      this.changeDrawPage(0);
      this.getCertificate();

   }

   ngAfterViewInit() {
      this._giveNullElement = this.allImages.nativeElement;
      this.handleToggleClosed();
      this.getProfile();
   }

   getWatermark() {
      if (this.tin === this.myFiles) {
         this.service.getWatermark('Web').subscribe((data) => {
            this.watermark = data;
         });
      } else {
         this.service.getWatermark('Web', this.tin).subscribe((data) => {
            this.watermark = data;
         });
      }

   }

   getCertificate() {
      this.service.get('cert/list')
      .subscribe((data) => {
         if (data) {
            this.certificateList = data;
         }
      }, error =>{
         this.toast.error(error.massage);
      });
   }

   /** เมื่อเปิดเข้ามาในหน้า เซ็นอกสารทำการเรียก service transform เพื่อดึงข้อมูลรูปภาพมาวางไว้ตั้งต้นก่อน */
   changeDrawPage(index) {
      this.clearAllPage();
      const token = this.service.user.token;
      this.picSign = this.service.url + '/signature?token=' + token + '&lastmodify=' + Date.now() + '&init=false';
      this.picInitSign = this.service.url + '/signature?token=' + token + '&lastmodify=' + Date.now() + '&init=true';
      if(this._docIds.length > 0){
         this.renditionIndex = index;
         this.service.transformPdf(this._docIds, undefined, true)
         .subscribe((data) => {
               this.watchRendition(data);
               this._statusInitial = [];
               this.transformHeight = 0;
               this._pageCount = 1;
               this._dataPages = data;
               this.mimType = this._dataPages[0].mimType;
               if (this.maxWidth < this._dataPages[index].maxWidth) {
                  this.maxWidth = this._dataPages[index].maxWidth;
               }
               this.maxHeight += this._dataPages[index].maxHeight;
               this._totalPages = this._dataPages[index].totalPages;
               for (let i = 0; i < this._totalPages; i++) {
                  this._statusInitial.push({'isInitial': false});
               }
               for (let i = 0; i < this.taskAttribute.docList.length; i++) {
                  this.taskAttribute.docList[i].totalPages = this._dataPages[i].totalPages;
               }
               this.checkpositionpage = true;
               for (let i = 0; i < this._totalPages; i++) {
                  if (this._dataPages[index].pages[i].width > this._dataPages[index].pages[i].height) {
                     this.checkpositionpage = false;
                     break;
                  }
               }
               if (!this.isToggleRightOpened) {
                  this.toggleRight.emit();
               }
               this.addItemPage(this._dataPages[index], 0);
               this.handleLoadPage(false);
               if (localStorage.getItem('first_sign-off_open') !== 'true') {
                  this.onStartTutorial();
                  localStorage.setItem('first_sign-off_open', 'true');
               }
            },
            err => {
               this.handleLoadPage(false);
               this.toast.error(err);
            });
      } else {
         this.handleLoadPage(false);
      }

      this.isInitail = true;
   }

   /** poll เอกสารที่ยังแปลงไม่เสร็จ แสดงผลทันทีเมื่อเอกสารที่เปิดอยู่แปลงเสร็จ */
   private watchRendition(data: any[]) {
      this.renditionWatcher.watch(data, ids => this.service.transformPdf(ids, undefined, true), (doc, i) => {
         if (!this._dataPages) {
            return;
         }
         this._dataPages[i] = doc;
         if (this.taskAttribute.docList[i]) {
            this.taskAttribute.docList[i].totalPages = doc.totalPages;
         }
         if (i === this.renditionIndex) {
            this.refreshPage(i);
         }
      }, () => this.renditionIndex);
   }

   ngOnDestroy() {
      // ออกจากหน้า/cancel: เอาไฟล์ที่ยังรอแปลงออกจากคิวของ backend (ไฟล์ที่กำลังแปลงอยู่จะทำต่อจนเสร็จ)
      this.renditionWatcher.release(ids => this.service.releasePdfTransform(ids));
   }

   /** เมื่อทำการกดที่รายการเอกสารจะทำการ bind data เป็นค่าเริ่มต้นใหม่ */
   refreshPage(index) {
      this.clearAllPage();
      const token = this.service.user.token;
      this.picSign = this.service.url + '/signature?token=' + token + '&lastmodify=' + Date.now() + '&init=false';
      this.picInitSign = this.service.url + '/signature?token=' + token + '&lastmodify=' + Date.now() + '&init=true';
      this.renditionIndex = index;
      this.service.transformPdf(this._docIds, undefined, true)
         .subscribe((data) => {
               this.watchRendition(data);
               this._statusInitial = [];
               this.transformHeight = 0;
               this._pageCount = 1;
               this._dataPages = data;
               if (this.maxWidth < this._dataPages[index].maxWidth) {
                  this.maxWidth = this._dataPages[index].maxWidth;
               }
               this.maxHeight += this._dataPages[index].maxHeight;
               this._totalPages = this._dataPages[index].totalPages;
               for (let i = 0; i < this._totalPages; i++) {
                  this._statusInitial.push({'isInitial': false});
               }
               for (let i = 0; i < this.taskAttribute.docList.length; i++) {
                  this.taskAttribute.docList[i].totalPages = this._dataPages[i].totalPages;
               }
               this.checkpositionpage = true;
               for (let i = 0; i < this._totalPages; i++) {
                  if (this._dataPages[index].pages[i].width > this._dataPages[index].pages[i].height) {
                     this.checkpositionpage = false;
                     break;
                  }
               }
               if (!this.isToggleRightOpened) {
                  this.toggleRight.emit();
               }
               this.addItemPage(this._dataPages[index], 0);
            },
            err => {
               this.handleLoadPage(false);
               this.toast.error(err);
            });
   }

   /** add รูปภาพต่อท้ายรูปที่แสดงทั้งหมดในปัจจุบัน */
   append(imgUrl: string, width: number, height: number, tranHeight: number, pageNo: number, maxWidth: number) {
      if (this.isZoom || this.isFitPage || !this.isToggleRightOpened) {
         width *= this.getCountZoom();
         height *= this.getCountZoom();
         tranHeight *= this.getCountZoom();
         maxWidth *= this.getCountZoom();
      }
      if (this.checkpositionpage) {
         if (maxWidth > width) {
            this.position = (maxWidth - width) / 2;
         } else {
            this.position = 0;
         }
      }
      if (!this.checkpositionpage) {
         if (width >= height) {
            this.position = 0;
         } else {
            this.position = (maxWidth - width) / 2;
         }
      }
      const $_img = $('#img_' + pageNo);
      if ($_img.length === 0) {
         this.allImages.nativeElement
            .insertAdjacentHTML('beforeEnd', '<g class="imageSign" draggable="false" id="img_'
               + pageNo + '" transform="matrix(1,0,0,1, ' + this.position + ', ' + tranHeight + ')" >' +
               '<image  draggable="false" width=' + width + ' height=' + height + ' href=' + imgUrl + ' class=center />' +
               '<text style="text-align: center" y=' + (height + 15) +
               ' x=' + (width - this.calculateLenStr(this.getLenNumber(pageNo), this.getLenNumber(this._totalPages))) + '>' +
               pageNo + ' of ' + this._totalPages + '</text>' + this.createWatermark(pageNo, width, height) + '</g>'
            );
      } else {
         $($_img.find('image')[0]).attr('href', imgUrl);
      }
   }

   createWatermark(pageNo, width, height) {
      let watermarkHTML = '';
      if (this.watermark && this.watermark != null) {
         let fontFamily = 'sans-serif';
         let color = '#33BBE6';
         let fontSize = '60';
         let opacity = 0.25;
         if (this.watermark.fontFamily) {
            fontFamily = this.watermark.fontFamily;
         }
         if (this.watermark.color) {
            color = this.watermark.color;
         }
         if (this.watermark.fontSize) {
            fontSize = this.watermark.fontSize;
         }
         if (this.watermark.opacity) {
            opacity = this.watermark.opacity / 100;
         }

         watermarkHTML = '<text dominant-baseline="middle" text-anchor="middle" ' +
            'fill="' + color + '" transform="translate(' + (width / 2) + ',' + (height / 2) + ') rotate(-45)" ' +
            'fill-opacity="' + opacity + '" font-size="' + (parseInt(fontSize, 10) * this.getCountZoom()) + '" font-family="' + fontFamily + '">' + this.watermark.text + '</text>';
      }
      return watermarkHTML;
   }

   /** ลบรูปภาพสุดท้ายออก */
   remove() {
      this.allImages.nativeElement.lastChild.remove();
   }

   /** เมื่อแทบ navigation มีการเปลี่ยนแปลงจะเข้า function callback นี้ */
   navChange(component, drawer) {
      this._isVisible = drawer._elementRef.nativeElement.style.visibility;
      if (drawer.opened) { // TODO : change position of menu on headerbar
         this.isHideArrowLeft = true;
         this.isHideArrowRight = false;
         this.handleToggleOpend();
         if (!this.isZoom && this.isToggleRightOpened) {
            this.isFitPage = true;
            this.handleFitPage(true);
         }
      } else {
         this.isHideArrowLeft = false;
         this.isHideArrowRight = true;
         this.handleToggleClosed();
         if (!this.isZoom && this.isToggleRightOpened) {
            this.isFitPage = false;
            this.handleFitPage(false);
         }
      }

   }

   /** วาด object ลายเซ็น ชื่อ วันที่ พร้อม ผูก event ให้แต่ละ object */
   drawSVG($event) {
      if (!this._eventMouseOver) {
         this._eventMouseOver = $event;
      }
      if (this.startDrawing) {
         if ($event.target.parentNode.id && !this.isDrawing) {
            this.setInitialPositionType();
            this.setInitialPageType();
            const id = this.checkImgFocus($event);
            if (this._objectSVG) {
               for (const object of this._objectSVG) {
                  if (id === object.id) {
                     this._draw = object.svg;
                     break;
                  }
               }
            }
            this.drawTypeSign(id, cb => {
               this.updateItemSign(this.currentIndex);
            });
            this._objDraw.on('beforedrag', (e) => { // หลัง object วาดเสร็จตั้งค่า event เมื่อคลิกที่ object
               this.isHideDeleteBtn = false;
               this.setVisibleTextProperties(e);
               this.handleChangeTab();
               if (!this.isDrawing) {
                  this._objDraw = '';
               }
               this._objectDrag = e.target;
               const $id = $(e.target).attr('id');
               this.deselectAllWithOutMatchId($id);
               if (this.taskAttribute.docList[this.currentIndex].signItems) {
                  for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
                     if (item.idSignItem === $id) {
                        this.setProperties(item, $id);
                        const index = this.leftPanelComp.toolsComp.signers.findIndex((data) => data.signerEmail.toLowerCase() === item.signer.toLowerCase());
                        this.leftPanelComp.toolsComp.selected = index;
                        this.isHideProperties = false;
                        this._isHideProp = false;
                        break;
                     }
                  }
               }
            });
            this._objDraw.on('beforedrag', function (e) { // หลัง object วาดเสร็จตั้งค่า event เมื่อคลิกที่ object
               if (typeName === 'sign' || typeName === 'signTask') { // เปลี่ยนรูปเมาส์
                  this.attr({'cursor': 'move'});
               } else {
                  this.attr({'cursor': 'move'});
                  this.children()[0].attr({'cursor': 'move'});
                  this.children()[1].attr({'cursor': 'move'});
               }
               this.selectize({ // ซ่อนปุ่มขยาย หมุน
                  points: false,
                  rotationPoint: false
               });
            });
            this._objDraw.on('dragstart.namespace', (e) => { // เมื่อเริ่มลาก object จะทำ event ตามนี้
               this.setVisibleTextProperties(e);
               if (this._draw) {
                  for (const item of this._draw.children()) {
                     if (item.type !== 'g') { // ซ่อนกรอบ select object อื่นทิ้ง
                        item.selectize(false);
                     }
                  }
               }
               this._onDrag = true; // ตั้งค่าตัวแปร flag drag
               onDrag = true;
               this._objectDrag = e.target; // เก็บ object drag ที่เลือกปัจจุบันล่าสุด
            });
            this._objDraw.on('dragmove.namespace', function (e) { // คำนวณการเคลื่อนไหวไหมของ object
               if (changeImage) {
                  e.preventDefault();
                  this.move(e.detail.event.offsetX, e.detail.event.offsetY);
               }
            });
            this._objDraw.on('dragend.namespace', function (e) { // เมื่อการลาก object จบจะเข้า event นี้
               if (typeName === 'sign' || typeName === 'signTask') {
                  this.attr({'cursor': 'pointer'}); // เปลี่ยนรูปเมาส์กลับเป็นปกติ
                  if (this.type === 'image') { // ให้ resize ได้เฉพาะมุมเท่านั้น โดยคง ration ให้คงเดิม
                     this.selectize({
                        points: ['lt', 'rt', 'rb', 'lb'],
                        rotationPoint: false
                     }).resize({saveAspectRatio: true});
                  } else {
                     this.selectize({
                        points: false,
                        rotationPoint: false
                     });
                  }
               } else {
                  this.attr({'cursor': 'pointer'}); // เปลี่ยนรูปเมาส์กลับเป็นปกติ
                  this.children()[0].attr({'cursor': 'pointer'});
                  this.children()[1].attr({'cursor': 'pointer'});
                  this.selectize({
                     points: false,
                     rotationPoint: false
                  });
               }
               changeImage = false;
               onDrag = false; // ตั้งค่าตัวแปร flag ของ drag เพื่อให้รู้ว่า drag จบแล้ว
            });
            this._objDraw.on('dragend.namespace', (e) => { // เมื่อการลาก object จบจะเข้า event นี้
               this.isDrawing = false; // ตั้งค่าตัวแปร flag ของ drawing เพื่อให้รู้ว่า drawing จบแล้ว
               if (($(e.target).attr('fieldType') !== this._keyFieldType.checkbox) && ($(e.target).attr('fieldType') !== this._keyFieldType.image)) {
                  this.calculateOutBoundItem(e);
               } else {
                  this.calculateOutBoundItemImage(e);
               }
               if ($(e.target).attr('fieldType') === this._keyFieldType.text) {
                  this.setTextStyle();
               }
               this.updateItemsSignCurrentPage();
               this.finishSVG('');
               this.setVisibleTextProperties(e);
               this._onDrag = false; // ตั้งค่าตัวแปร flag ของ drag เพื่อให้รู้ว่า drag จบแล้ว
            });
            this._objDraw.on('dragover', (e) => { // เมื่อลาก object มาวางไว้ที่หน้าเอกสารต้องเคลียร์ event ให้ไม่ขึ้นรูปห้าม drag
               e.preventDefault();
               e.stopPropagation();

            });
            this._objDraw.on('resizing', (e) => { // เมื่อทำการ resize object จะเข้า action นี้
               if (!this.isDrawing) {
                  this._objDraw = ''; // เคลียร์ค่า object นี้ทิ้งเพื่อไม่ให้ซ้ำซ้อนตอนที่เก็บ object เข้า taskAttribute
               }
               this._objectDrag = e.target; // เก็บ object drag ที่เลือกปัจจุบันล่าสุด
            });
            this._objDraw.on('resizedone', (e) => { // เมื่อ resize จบจะเข้า action นี้
               this.updateItemsSignCurrentPage();
            });
            this.setFontSignText();
            if ($(this._objDraw.node).attr('fieldType') === this._keyFieldType.text) {
               this.setTextStyle();
            }
            if (this._objDraw.type === 'image') {
               this._objDraw.selectize({ // ให้ resize ได้เฉพาะมุมเท่านั้น โดยคง ration ให้คงเดิม
                  points: ['lt', 'rt', 'rb', 'lb'],
                  rotationPoint: false
               }).resize({saveAspectRatio: true});
            } else {
               this._objDraw.selectize({
                  points: false,
                  rotationPoint: false
               });
            }
            this._objDraw.draggable(); // ตั้งค่าให้ object สามารถ drag ได้
            if (!this._isDrag) { // เช็คกรณีที่วาดรูปลงหน้าเอกสาร
               this.isDrawing = true; // ตั้งค่า flag drawing เพื่อให้รู้ว่ากำลังวาด object อยู่
            } else {
               this.calculateMove($event);
               this._isDrag = false;
               this.isDrawing = false;
               this.updateItemsSignCurrentPage();
            }
            this.startDrawing = false; // ตั้งค่า flag เพื่อให้รู้ว่าเริ่มการวาดแล้ว
            this._idSignitems = $(this._objDraw.node).attr('id'); // เก็บค่า id ของ object ล่าสุด
            this._isHideProp = false; // ตั้งค่า flag ว่าจะให้ซ่อนตัวตั้งค่า properties ไหม
            this.isHideDeleteBtn = false; // ตั้งค่า flag ว่าจะให้ซ่อยปุ่ม delete ไหม
            this._isChangeSigner = false; // ตั้งค่า flag ว่ามีการเปลี่ยน signer ไหม
            this.isHideProperties = false;
         }
      }
   }

   /** วาดรูป object ในรูปแบบที่เป็นรูป */
   drawTypeSign(id, cb) {
      let ratio;
      const pageNum = id.split('_')[1];
      let strLen;
      const ratioZoom = this.getCountZoom();
      const that = this;
      switch (this._fieldType) {
         case 'signature':
           this._objDraw = this._draw.image(this.picSign).loaded(function (loader) { // คำนวณ ratio รูปภาพให้ขนาด match กัน
               ratio = loader.width / widthInit;
               if (loader.height / ratio <= heightInit) {
                  this.size(widthInit * ratioZoom, (loader.height / ratio) * ratioZoom);
               } else {
                  ratio = loader.height / heightInit;
                  this.size((loader.width / ratio) * ratioZoom, heightInit * ratioZoom);
               }
               cb();
            }).attr({
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'signer': this.service.user.email,
               'positionType': this.positionType,
               'pageType': this.pageType,
               'chkName': this.chkName,
               'chkDate': this.chkDate,
               'cursor': 'pointer',
               'pageNum': pageNum,
               'fieldType': this._keyFieldType.signature,
               'stepOrder': 1
            });
            this.service.getProfileByUserName(this.service.user.email).subscribe(data => {
               if (!this.chkApplyAll) {
                  this.chkName = data.includeName;
                  this.chkDate = data.includeDate;
               }
               this._objDraw.attr({
                  'chkName': this.chkName,
                  'chkDate': this.chkDate
               });
               let chkName = this._objDraw.attr('chkName');
               let chkDate = this._objDraw.attr('chkDate');
               if (chkName || chkDate) {
                  let width: number = this._objDraw.attr('width');
                  this._objDraw.attr('width', (width + (50 * ratioZoom)));
               }
               this.editSignature(this._objDraw,chkName === 'true',chkDate === 'true');
            });
            break;
         case 'initSignature': // initial
            this._objDraw = this._draw.image(this.picInitSign).loaded(function (loader) { // คำนวณ ratio รูปภาพให้ขนาด match กัน
               ratio = loader.width / widthInitInit;
               if (loader.height / ratio <= heightInitInit) {
                  this.size(widthInitInit * ratioZoom, (loader.height / ratio) * ratioZoom);
               } else {
                  ratio = loader.height / heightInitInit;
                  this.size((loader.width / ratio) * ratioZoom, heightInitInit * ratioZoom);
               }
               cb();
            }).attr({
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'signer': this.service.user.email,
               'positionType': this.positionType,
               'pageType': this.pageType,
               'cursor': 'pointer',
               'pageNum': pageNum,
               'fieldType': this._keyFieldType.initSignature,
               'stepOrder': 1
            });
            break;
         case 'name':
            strLen = this._user.name.length;
            this._objDraw = this._draw.text(this._user.name).addClass(this._keyFieldType.name).attr({
               'signer': this.service.user.email,
               'positionType': this.positionType,
               'pageType': this.pageType,
               'cursor': 'pointer',
               'pageNum': pageNum,
               'width': this.calculateLenStrSign(this._user.name),
               'height': 13,
               'fieldType': 'name',
               'stepOrder': 1
            });
            this._objDraw.font({size: this._fontSize * ratioZoom, family: 'THSarabunNew'});
            break;
         case 'date':
            const day = moment().format('DD/MM/YYYY');
            strLen = day.toString().length;
            this._objDraw = this._draw.text(day).addClass(this._keyFieldType.date).attr({
               'signer': this.service.user.email,
               'positionType': this.positionType,
               'pageType': this.pageType,
               'cursor': 'pointer',
               'pageNum': pageNum,
               'width': this.calculateLenStrSign(day.toString()),
               'height': 13,
               'fieldType': 'date'
            });
            this._objDraw.font({size: this._fontSize * ratioZoom, family: 'THSarabunNew'});
            break;
         case 'text':
            const txt = this._text;
            strLen = txt.length;
            this._objDraw = this._draw.text(txt).addClass(this._keyFieldType.text).attr({
               'signer': this.service.user.email,
               'positionType': this.positionType,
               'pageType': this.pageType,
               'cursor': 'pointer',
               'pageNum': pageNum,
               'width': this.calculateLenStrSign(txt),
               'height': 13,
               'fieldType': 'text',
               'fontStyle': 'THSarabunNew',
               'fontSize': this._fontSize,
               'fontColor': '#000000',
               'fontBold': false,
               'fontItalic': false,
               'fontUnderline': false,
               'textRequired': false,
               'stepOrder': 1
            });
            this._objDraw.font({size: this._fontSize * ratioZoom, family: 'THSarabunNew'});
            this.generateTextControl(this._objDraw, this._text);
            break;
            case 'image':
               this._objDraw =  this._draw.image(this.picAttachImg).loaded(function (loader) {
                  ratio = loader.width / widthAttachInit;
                  if (loader.height / ratio <= heightAttachInit) {
                     this.size(widthAttachInit * ratioZoom, (loader.height / ratio) * ratioZoom);
                  } else {
                     ratio = loader.height / heightAttachInit;
                     this.size((loader.width / ratio) * ratioZoom, heightAttachInit * ratioZoom);
                  }
               }).addClass(this._keyFieldType.image)
                  .attr({
                     fill: 'none', stroke: this.colors[0], 'stroke-width': 10, 'signer': this.service.user.email,
                     'positionType': this.positionType, 'pageType': this.pageType, 'cursor': 'pointer',
                     'pageNum': pageNum, 'fieldType': this._keyFieldType.image, 'class': 'image',
                     'stepOrder': 1
                  });
            break;
         case 'checkbox':
            const moveX = (this._widthInitCheckBox / 2) - (this._widthInitBox / 2);
            const moveY = (this._heightInitCheckBox / 2) - (this._heightInitBox / 2);
            let rect = this._draw.rect(this._heightInitCheckBox * ratioZoom, this._widthInitCheckBox * ratioZoom).fill('transparent');
            let checkbox = this._draw.rect(this._widthInitBox * ratioZoom, this._heightInitBox * ratioZoom).move(moveX * ratioZoom, moveY * ratioZoom).fill('transparent').stroke({ color: '#000', width: 1 });
            let flag = this._draw.image(this.picCheckBox).loaded(function (loader) {
               ratio = loader.width / that._widthInitCheck;
               if (loader.height / ratio <= that._heightInitCheck) {
                  this.size(that._widthInitCheck * ratioZoom, (loader.height / ratio) * ratioZoom);
               } else {
                  ratio = loader.height / that._heightInitCheck;
                  this.size((loader.width / ratio) * ratioZoom, that._heightInitCheck * ratioZoom);
               }
            }).attr({
               x: ((this._widthInitCheckBox / 2) - (this._widthInitCheck / 2))  * ratioZoom,
               y: ((this._heightInitCheckBox / 2) - (this._heightInitCheck / 2))  *  ratioZoom,
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'cursor': 'pointer',
               'class': 'image'
            });


            this._objDraw = this._draw.group().addClass(this._keyFieldType.checkbox).attr({
               'signer': this.service.user.email,
               'positionType': this.positionType,
               'pageType': this.pageType,
               'cursor': 'pointer',
               'pageNum': pageNum,
               'width': this._widthInitBox * ratioZoom,
               'height': this._heightInitBox * ratioZoom,
               'fieldType': this._keyFieldType.checkbox,
               'isExists': false,
               'stepOrder': 1
            });

            this.renderCheckBox(this._objDraw, checkbox, flag);

            this._objDraw.add(rect);
            this._objDraw.add(checkbox);
            this._objDraw.add(flag);
            break;
         default:
            break;
      }
   }

   getImageContent(id){
      if(id !== this.picAttachImg){
         return this.service.url + '/share-public/content?id=' + id;
      } else {
         return this.picAttachImg;
      }
   }

   setVisibleTextProperties(e) {
      const fieldType = $(e.target).attr('fieldType');
      this._fieldType = fieldType;
   }

   /** หา id ที่รูปที่เลือกอยู่ focus ไว้ */
   checkImgFocus($event) {
      this._imgFocus = $event;
      let id, imgTarget;
      if (this._imgFocus.target.parentNode.className !== 'imageSign') {
         imgTarget = this.findImageParent(this._imgFocus.target);
         id = imgTarget.parentNode.id;
         this._imgFocusCal = imgTarget; // ตั้งค่าเอกสารที่ focus อยู่
      } else {
         id = this._imgFocus.target.parentNode.id;
         this._imgFocusCal = this._imgFocus.target; // ตั้งค่าเอกสารที่ focus อยู่
      }
      return id;
   }

   /** เคลื่อนที่ของรูป object */
   moveSVG($event) {
      if (this.isDrawing) { // เช็คตัวแปร flag ว่าเป็นการ drawing ไหม
         this._moveOnPage = true;
         this.calculateMove($event);
      }
      if (this._onDrag) { // เช็คตัวแปร flag ว่าเป็นการ drag ไหม
         const $objectDrag = $(this._objectDrag);
         const id = $objectDrag.attr('id');
         $objectDrag.attr('positionType', 'CT');
         if (this.taskAttribute.docList[this.currentIndex].signItems) {
            for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
               if (item.idSignItem === id) {
                  this.setInitialPositionType();
                  break;
               }
            }
         }
      }
   }

   /** คำนวณเคลื่อนที่ของรูป object มีการตรวจสอบว่าชิดขอบหรือไม่ชิดขอบ */
   calculateMove($event) {
      const id = this._imgFocusCal.parentNode.id;
      const h = this.calculatePageHeightMargin(id);
      const type = $(this._objDraw.node).attr('fieldType');
      const width = $(this._objDraw.node).attr('width');
      const height = $(this._objDraw.node).attr('height');
      const calDiffMaxWidth = (this.maxWidth * this.getCountZoom() - this._imgFocusCal.width.baseVal.value) / 2;
      const realX = $event.layerX - calDiffMaxWidth;
      let difX, difY, inBoundX, inBoundY;
      const borderWidth = 10 * this.getCountZoom();
      const borderHeight = 5 * this.getCountZoom();
      if (type === 'signature' || type === 'initSignature' || type === 'image') {
         difX = (width / 2);
         difY = (height / 2);
         inBoundX = (width / 2);
         inBoundY = (height / 2);
         if ($event.layerY + inBoundY < this._imgFocusCal.height.baseVal.value + h && realX
            + inBoundX < this._imgFocusCal.width.baseVal.value && realX - inBoundX > 0 && $event.layerY - inBoundY > h) {
            this._objDraw.center(realX - borderWidth, $event.layerY - h - borderHeight);
         } else {
            if ($event.layerY + difY >= this._imgFocusCal.height.baseVal.value + h) { // bottom
               if (realX - difX > 0) {
                  if (realX + difX <= this._imgFocusCal.width.baseVal.value) {
                     this._objDraw.center(realX, this._imgFocusCal.height.baseVal.value - difY);
                  } else {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, this._imgFocusCal.height.baseVal.value - difY);
                  }
               } else {
                  this._objDraw.center(difX, this._imgFocusCal.height.baseVal.value - difY);
               }
            } else if (realX + difX >= this._imgFocusCal.width.baseVal.value) { // right
               if ($event.layerY - difY > h) {
                  if ($event.layerY + difY <= this._imgFocusCal.height.baseVal.value + h) {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, $event.layerY - h);
                  } else {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, difY);
                  }
               } else {
                  this._objDraw.center(this._imgFocus.target.width.baseVal.value - difX, difY);
               }
            } else if (realX - difX <= 0) { // left
               if ($event.layerY - difY > h) {
                  this._objDraw.center(difX, $event.layerY - h);
               } else {
                  this._objDraw.center(difX, difY);
               }
            } else if ($event.layerY - difY <= h) {
               this._objDraw.center(realX, difY);
            }
         }
      } else {
         difX = width / 2 * this.getCountZoom();
         difY = 10 * this.getCountZoom();
         inBoundX = width / 2 * this.getCountZoom();
         inBoundY = 10 * this.getCountZoom();
         if ($event.layerY + inBoundY < this._imgFocusCal.height.baseVal.value + h && realX
            + inBoundX < this._imgFocusCal.width.baseVal.value && realX - inBoundX > 0 && $event.layerY - inBoundY > h) {
            this._objDraw.center(realX, $event.layerY - h);
         } else {
            if ($event.layerY + difY >= this._imgFocusCal.height.baseVal.value + h) { // bottom
               if (realX - difX > 0) {
                  if (realX + difX <= this._imgFocusCal.width.baseVal.value) {
                     this._objDraw.center(realX, this._imgFocusCal.height.baseVal.value - difY);
                  } else {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, this._imgFocusCal.height.baseVal.value - difY);
                  }
               } else {
                  this._objDraw.center(difX, this._imgFocusCal.height.baseVal.value - difY);
               }
            } else if (realX + difX >= this._imgFocusCal.width.baseVal.value) { // right
               if ($event.layerY - difY > h) {
                  if ($event.layerY + difY <= this._imgFocusCal.height.baseVal.value + h) {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, $event.layerY - h);
                  } else {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, difY);
                  }
               } else {
                  this._objDraw.center(this._imgFocus.target.width.baseVal.value - difX, difY);
               }
            } else if (realX - difX <= 0) { // left
               if ($event.layerY - difY > h) {
                  this._objDraw.center(difX, $event.layerY - h);
               } else {
                  this._objDraw.center(difX, difY);
               }
            } else if ($event.layerY - difY <= h) {
               this._objDraw.center(realX, difY);
            } else {
               // this._objDraw.center($event.layerX -10, $event.layerY - h -5);
            }
         }
      }
   }

   /** เมื่อวาด object เสร็จแล้วจะทำการตั้งค่าเริ่มต้นต่างๆให้กับ object นั้น */
   finishSVG($event) {
      if (this.startDrawing) {
         this._moveOnPage = false;
         this.isDrawing = false;
         if (this._objDraw.type === 'image') {
            this._objDraw.selectize({
               points: ['lt', 'rt', 'rb', 'lb'],
               rotationPoint: false
            }).resize({saveAspectRatio: true});
         } else {
            this._objDraw.selectize({
               points: []
            });
         }
         this.startDrawing = false;
      }
      if (!this._isDeselect) {
         if (this.leftPanelComp.toolsComp) {
            this.leftPanelComp.toolsComp.isExpanded = true;
         }
         if (this._isHideProp) {
            this.setVisibleProperty(false);
         } else {
            this.setVisibleProperty(true);
         }
      }
      this._isDeselect = false;
   }

   /** ตั้งค่าเริ่มต้นต่างๆเมื่อวาง object ที่ drag ลง กรณีที่ปล่อยเมาส์ข้างนอกเอกสาร */
   outzoneSVG($event) {
      if (this._objDraw) {
         if (this.leftPanelComp.toolsComp) {
            this.leftPanelComp.toolsComp.isExpanded = true;
         }
         if (this._isHideProp) {
            this.setVisibleProperty(false);
         } else {
            this.setVisibleProperty(true);
         }
      }
   }

   /** ตั้งค่าเมื่อมีการยกเลิกการ select object นั้น */
   setDeselectItem($event) {
      this._isDeselect = true;
      if (this.leftPanelComp.toolsComp) {
         this.leftPanelComp.toolsComp.isExpanded = true;
      }
      this.leftPanelComp.visiblityState = false;
      if (!this.isDrawing) {
         this.deselectAll();
         if (!this.isDrawing) {
            this._objDraw = '';
         }
         this._objectDrag = '';
      }
   }

   /** ยกเลิกการ select ของทุก object */
   deselectAll() {
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (object.svg) {
               for (const item of object.svg.children()) {
                  if ((item.type === 'text' || item.type === 'image' || item.type === 'g')) {
                     if (item.attr('signer')) {
                        item.selectize(false);
                     }
                  }
               }
            }
         }
      }
   }

   /** ยกเลิกการ select ของทุก object ยกเว้น id ที่รับเข้ามา */
   deselectAllWithOutMatchId(id) {
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (object.svg) {
               for (const item of object.svg.children()) {
                  if ((item.type === 'text' || item.type === 'image' || item.type === 'g')) {
                     if (item.attr('signer') && item.attr('id') !== id) {
                        item.selectize(false);
                     }
                  }
               }
            }
         }
      }
   }

   /** ตั้งค่าต่างๆเมื่อคลิกเมนูเพื่อทำการวาด object */
   handleMenuClick() {
      const signMenuClick = this.signMenuClick
         .subscribe((data) => {
            this._flagMouseOver = false;
            this._fieldType = data;
            this.startDrawing = true;
            this.isDrawing = false;
            if (this._draw) {
               for (const item of this._draw.children()) {
                  if (item.type === 'image' || item.type === 'text' || item.type === 'g') {
                     if (item._event) {
                        item.selectize(false);
                     }
                  }
               }
            }
         });
   }

   /** ตั้งค่าต่างๆเมื่อลากที่เมนูเพื่อทำการวาด object */
   handleMenuDrag() {
      const signMenuDrag = this.signMenuDrag
         .subscribe((data) => {
            this._fieldType = data;
            if (this._draw) {
               for (const item of this._draw.children()) {
                  if (item.type === 'image' || item.type === 'text' || item.type === 'g') {
                     if (item._event) {
                        item.selectize(false);
                     }
                  }
               }
            }
         });
   }

   /** ตั้งค่า object ให้ signItem ของ taskAttribute ที่จะทำการส่งไปฝั่ง service */
   setSignItem(signer, fieldType, pageType, pageNum, positionType, chkName, chkDate, coordinateX, coordinateY, fieldWidth,
               fieldHeight, id, order, content?, flagSign?, idImageItem?, fontStyle?, fontSize?, fontColor?, fontBold?, fontItalic?, fontUnderline?, textRequired?, flagCheckbox?) {
      if (content === 'Input Text' || content === 'กรอกข้อความ') {
         content = '';
      }
      this._signItem = {
         'signer': signer
         , 'fieldType': fieldType
         , 'pageType': pageType
         , 'pageNum': pageNum
         , 'positionType': positionType
         , 'chkName': chkName
         , 'chkDate': chkDate
         , 'coordinateX': coordinateX
         , 'coordinateY': coordinateY
         , 'fieldWidth': fieldWidth
         , 'fieldHeight': fieldHeight
         , 'idSignItem': id
         , 'order': order
         , 'flagSign': flagSign
         , 'content': content
         , 'idImageItem': idImageItem
         , 'fontStyle': fontStyle
         , 'fontSize': fontSize
         , 'fontColor': fontColor
         , 'fontBold': fontBold
         , 'fontItalic': fontItalic
         , 'fontUnderline': fontUnderline
         , 'textRequired': textRequired
         , 'flagCheckbox': flagCheckbox
         , 'stepOrder': 1
      };
   }

   /** ตั้งค่า doclist ของ taskAttribute ที่จะทำการส่งไปฝั่ง service */
   setDocListItem(docId, totalPages, signItems, siteId, certId, tempId) {
      this._docListItem = {
         'docId': docId,
         'totalPages': totalPages,
         'signItems': signItems,
         'siteId': siteId,
         'certId': certId,
         'tempId': tempId,
      };
   }

   /** เปิด dialog เพื่อให้กำหนดรูปลายเซ็น */
   openUpdateSignatureDraw(signatureId: any, initialId: any, fullName: any, $event) {
      this.setDialogRegistSignature(signatureId, initialId, fullName);
      this.registerSignDialog.afterClosed().subscribe(result => {
         if (result) {
            this.service.getProfile()
               .subscribe((data: any) => {
                  this.hasSignature = data.hasSignature;
                  this.hasInitial = data.hasInitial;
               });
            this.leftPanelComp.toolsComp.hasSignature = this.hasSignature;
            this.leftPanelComp.toolsComp.hasInitial = this.hasInitial;
            this.startDrawing = true;
            this.drawSVG($event);
            this._isDrag = false;
            this.startDrawing = false;
            $event.preventDefault();
         }
      });
   }

   /** เปิด Dialog เพื่อให้ตั้งค่า password */
   openChangePassword() {
      this.changePasswordDialog = this.dialog.open(SetpasswordDialogComponent, {
         disableClose: true,
         data: this,
         width: '350px'
      });
      this.changePasswordDialog.afterClosed().subscribe((result) => {
         this._isFirstSingIn = false;
         if (localStorage.getItem('first_sign-off_open') !== 'true') {
            this.onStartTutorial();
            localStorage.setItem('first_sign-off_open', 'true');
         }
      });
   }

   /** เมื่อมีการวาด object ลงบนเอกสารจะทำการ bind data เข้า object signItem ใน taskAttribute */
   addItemSign(index, yMarginSign?) {
      let pageNo, countCurrent = 0, giveArray = [], img;
      if (!this._onClickDelete) {
         if (this._objectSVG) {
            for (const object of this._objectSVG) {
               if (object.svg) {
                  for (const item of object.svg.children()) {
                     if (item.attr('signer')) { // นับค่า object ที่พึ่งวาดลงเอง เพื่อทำการลบออกจาก signItem ให้ถูกต้อง
                        if (this._objDraw) {
                           if (this._objDraw.attr('id') !== item.attr('id')) {
                              countCurrent++;
                           } else if (this._isChangeSigner) {
                              countCurrent++;
                           }
                        } else {
                           countCurrent++;
                        }
                     }
                  }
               }
            }
         }
         if (this.taskAttribute.docList[index].signItems) {
            this.taskAttribute.docList[index].signItems.splice(0, countCurrent); // ลบออกตามจำนวนตามเงื่อนไขด้านบน
         }
         if (this.taskAttribute.docList[index].signItems) {
            giveArray = this.taskAttribute.docList[index].signItems.slice(); // copy ค่า array เอาไว้เพื่อที่จะไป bind data เข้าใหม่
         }
      }
      this.taskAttribute.docList[index].signItems = [];
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (object.svg) {
               for (const item of object.svg.children()) {
                  if ((item.type === 'text' || item.type === 'image' || item.type === 'g') && $(item.node).attr('signer')) {
                     let fieldType, pageType, chkName, chkDate, positionType, idSignItem, y, content, idImageItem, fontStyle, fontSize, fontColor, fontBold, fontItalic, fontUnderline, textRequired,flagCheckbox;
                     pageNo = $(item.node).attr('pageNum');
                     pageType = $(item.node).attr('pageType');
                     positionType = $(item.node).attr('positionType');
                     chkName = ($(item.node).attr('chkName') === 'true');
                     chkDate = ($(item.node).attr('chkDate') === 'true');
                     idSignItem = $(item.node).attr('id');
                     if (yMarginSign) {
                        y = item.y() + yMarginSign;
                     } else {
                        y = item.y();
                     }
                     fieldType = $(item.node).attr('fieldType');
                     content = '';
                     if (fieldType === 'text') {
                        content = item.node.textContent;
                        fontStyle = $(item.node).attr('fontStyle');
                        fontSize = Number($(item.node).attr('fontSize'));
                        fontColor = $(item.node).attr('fontColor');
                        fontBold = ($(item.node).attr('fontBold') === 'true');
                        fontItalic = ($(item.node).attr('fontItalic') === 'true');
                        fontUnderline = ($(item.node).attr('fontUnderline') === 'true');
                        textRequired = ($(item.node).attr('textRequired') === 'true');
                     } else if (fieldType === 'image'){
                        idImageItem = $(item.node).attr('ref');
                     } else if (fieldType === 'checkbox') {
                        flagCheckbox = ($(item.node).attr('flagCheckbox') === 'true');
                     }
                     if (item.type === 'g') {
                        this.setSignItem(this._signer
                           , fieldType
                           , pageType
                           , pageNo
                           , positionType
                           , chkName
                           , chkDate
                           , item.x()
                           , y
                           , item.children()[0].width()
                           , item.children()[0].height()
                           , idSignItem
                           , item.attr('order')
                           , content
                           , false
                           , idImageItem
                           , fontStyle
                           , fontSize
                           , fontColor
                           , fontBold
                           , fontItalic
                           , fontUnderline
                           , textRequired
                           , flagCheckbox
                        );
                     } else {
                        this.setSignItem(this._signer
                           , fieldType
                           , pageType
                           , pageNo
                           , positionType
                           , chkName
                           , chkDate
                           , item.x()
                           , y
                           , item.width()
                           , item.height()
                           , idSignItem
                           , item.attr('order')
                           , content
                           , false
                           , idImageItem
                           , fontStyle
                           , fontSize
                           , fontColor
                           , fontBold
                           , fontItalic
                           , fontUnderline
                           , textRequired
                           , flagCheckbox
                        );
                     }
                     if (this._objDraw !== '') {
                        if (this._objDraw.attr('id') !== item.attr('id') || (!this.isDrawing)) {
                           this.taskAttribute.docList[index].signItems.push(this._signItem);
                        }
                     } else {
                        this.taskAttribute.docList[index].signItems.push(this._signItem);
                     }
                  }
               }
            }

         }
      }
      if (this.taskAttribute.docList[this.currentIndex].signItems) {
         for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
            if (this._idSignitems === item.idSignItem) {
               this._fieldType = item.fieldType;
            } else {
               if (document.activeElement instanceof HTMLElement) {
                  document.activeElement.blur();
               }
            }
         }
      }
      if (!this._onClickDelete) {
         if (giveArray.length > 0) {
            for (const object of giveArray) {
               this.taskAttribute.docList[index].signItems.push(object);
            }
         }
         if(this.leftPanelComp.show){
            setTimeout(() => {
               this.leftPanelComp.scrollDown();
            },50);
         }
      }
   }

   /** อัพเดทค่า object กรณี sign หลังที่คำนวณ ratio ของรูปเสร็จแล้ว */
   updateItemSign(index, yMarginSign?) {
      let pageNo,img;
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (object.svg) {
               for (const item of object.svg.children()) {
                  if ((item.type === 'text' || item.type === 'image' || item.type === 'g') && $(item.node).attr('signer')) {
                     let fieldType, pageType, positionType, chkName, chkDate, idSignItem, y, content, idImageItem, fontStyle, fontSize, fontColor, fontBold, fontItalic, fontUnderline, textRequired, flagCheckbox;
                     pageNo = $(item.node).attr('pageNum');
                     pageType = $(item.node).attr('pageType');
                     positionType = $(item.node).attr('positionType');
                     chkName = ($(item.node).attr('chkName') === 'true');
                     chkDate = ($(item.node).attr('chkDate') === 'true');
                     idSignItem = $(item.node).attr('id');
                     if (yMarginSign) {
                        y = item.y() + yMarginSign;
                     } else {
                        y = item.y();
                     }
                     switch (item.type) {
                        case 'image' :
                           if ($(item.node).attr('fieldType')  === 'initSignature') {
                              fieldType = 'initSignature';
                           } else if ($(item.node).attr('fieldType')  === 'signature') {
                              fieldType = 'signature';
                           } else if ($(item.node).attr('fieldType')  === 'image') {
                              fieldType = 'image';
                           }
                        case 'text':
                           fieldType = $(item.node).attr('class');
                           break;
                        default:
                           break;
                     }
                     content = '';
                     if (fieldType === 'text') {
                        content = item.node.textContent;
                        fontStyle = $(item.node).attr('fontStyle');
                        fontSize = Number($(item.node).attr('fontSize'));
                        fontColor = $(item.node).attr('fontColor');
                        fontBold = ($(item.node).attr('fontBold') === 'true');
                        fontItalic = ($(item.node).attr('fontItalic') === 'true');
                        fontUnderline = ($(item.node).attr('fontUnderline') === 'true');
                        textRequired = ($(item.node).attr('textRequired') === 'true');
                     } else if (fieldType === 'image'){
                        idImageItem = $(item.node).attr('ref');
                     } else if (fieldType === 'checkbox') {
                        flagCheckbox = ($(item.node).attr('flagCheckbox') === 'true');
                     }
                     this.setSignItem(this._signer
                        , fieldType
                        , pageType
                        , pageNo
                        , positionType
                        , chkName
                        , chkDate
                        , item.x()
                        , y
                        , item.width()
                        , item.height()
                        , idSignItem
                        , item.attr('order')
                        , content
                        , false
                        , idImageItem
                        , fontStyle
                        , fontSize
                        , fontColor
                        , fontBold
                        , fontItalic
                        , fontUnderline
                        , textRequired
                        , flagCheckbox
                     );
                     if (this.taskAttribute.docList[index].signItems) {
                        const indexSignItem = this.taskAttribute.docList[index].signItems
                           .findIndex(signItem => signItem.idSignItem === idSignItem);
                        if (indexSignItem !== -1) {
                           this.taskAttribute.docList[index].signItems[indexSignItem] = this._signItem;
                        }
                     }
                  }
               }
            }

         }
      }
   }

   /** bind data เข้า signItem หลังมีการวาด object เข้าใหม่ หรือมีการเปลี่ยนแปลง object นั้น */
   updateItemsSignCurrentPage() {
      this.addItemSign(this.currentIndex);
   }

   /** add object ลง signItem เพื่อที่จะส่งให้ service */
   addItemsSign() {
      let img;
      this.taskAttribute.docList[0].signItems = [];
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            const pageNo = object.pageNo;
            if (object.svg) {
               for (const item of object.svg.children()) {
                  if ((item.type === 'text' || item.type === 'image' || item.type === 'g') && !this.isDrawing) {
                     let fieldType, pageType, positionType, chkName, chkDate, idSignItem, y, content, idImageItem, fontStyle, fontSize, fontColor, fontBold, fontItalic, fontUnderline, textRequired,flagCheckbox;
                     pageType = $(item.node).attr('pageType');
                     positionType = $(item.node).attr('positionType');
                     chkName = ($(item.node).attr('chkName') === 'true');
                     chkDate = ($(item.node).attr('chkDate') === 'true');
                     idSignItem = $(item.node).attr('id');
                     fieldType = $(item.node).attr('fieldType');
                     if (fieldType === 'checkbox') {
                        flagCheckbox = ($(item.node).attr('flagCheckbox') === 'true');
                     }
                     y = item.y();
                     if (fieldType) {
                        content = '';
                        if (fieldType === 'text') {
                           content = item.node.textContent;
                           fontStyle = $(item.node).attr('fontStyle');
                           fontSize = Number($(item.node).attr('fontSize'));
                           fontColor = $(item.node).attr('fontColor');
                           fontBold = ($(item.node).attr('fontBold') === 'true');
                           fontItalic = ($(item.node).attr('fontItalic') === 'true');
                           fontUnderline = ($(item.node).attr('fontUnderline') === 'true');
                           textRequired = ($(item.node).attr('textRequired') === 'true');
                        } else if (fieldType === 'image') {
                           idImageItem = $(item.node).attr('ref');
                        }
                        this.setSignItem(this._signer
                           , fieldType
                           , pageType
                           , pageNo
                           , positionType
                           , chkName
                           , chkDate
                           , item.x()
                           , y
                           , item.width()
                           , item.height()
                           , idSignItem
                           , item.attr('order')
                           , content
                           , false
                           , idImageItem
                           , fontStyle
                           , fontSize
                           , fontColor
                           , fontBold
                           , fontItalic
                           , fontUnderline
                           , textRequired
                           , flagCheckbox
                        );
                        this._signObjects.push(this._signItem);
                     }
                  }
               }
            }
         }
      }
   }

   /** ลบ object ที่วาดอยู่ทิ้งทั้งหมด */
   clearAllSign() {
      if (this._objectSVG) {
         for (const obj of this._objectSVG) {
            obj.svg.clear();
         }
      }
   }

   /** เคลื่อน scroll ไปตามหน้าที่กำหนดมา */
   warpPage(pageNo) {
      const imgCurrentId = 'img_' + pageNo;
      let  heightTotal, scrollTop;
      while (this._pageCount < pageNo) {
         if (!this._statusInitial[this._pageCount].isInitial) {
            this.addItemPage(this._dataPages[this.currentIndex], this._pageCount);
            this._statusInitial[this._pageCount].isInitial = true;
         }
         this._pageCount++;
      }
      heightTotal = this.getTotalPageHeight(imgCurrentId);
      scrollTop = heightTotal;
      if ((pageNo - this.pageNo1) > 7 || (pageNo - this.pageNo1) < -7) {
         $('#sideNavContent').animate({scrollTop: scrollTop}, 900);
         this.pageNo1 = pageNo;
      } else {
         $('#sideNavContent').animate({scrollTop: scrollTop});
         this.pageNo1 = pageNo;
      }
   }

   /** ลบรูปเอกสารทิ้งทั้งหมด */
   clearAllPage() {
      $('.imageSign').remove();
      this._objectSVG = [];
      this.maxWidth = 0;
      this.maxHeight = 0;

   }

   /** ตั้งค่าต่างๆเริ่มต้นใหม่ต่างๆ เมื่อทำการคลิกที่ list document */
   onListClick(object: {
      index: number;
      docId?: any;
      docName?: any;
      formName?: string;
      form?: Form;
   }) {
      this.setDeselectItem('');
      this.finishSVG('');
      this.pageNo1 = 1;
      this.page = 1;
      this.checkheightpage = 0;
      this.onscrollTum.emit(this.page);
      if (this.countZoom > 0) {
         this.checkheightpage = this.checkheightpage / 2;
         this.ZoomPage(false, this.countZoom.toFixed(1));
         this.updateItemsSignCurrentPage();
      }
      this.isZoom = false;
      this.countZoom = 0;
      this.viewDocumentComp.canZoomIn = true;
      this.viewDocumentComp.canZoomOut = false;
      this.isClickPage = true;
      this.isLoopPage = false;
      this.clearAllSign();
      this.addItemSign(this.currentIndex);
      this.refreshPage(object.index);
      this.currentIndex = object.index;
      this.mimType = this._dataPages[this.currentIndex].mimType;
      this.listClickEvent.emit(object.docId);
      if (this.leftPanelComp.signListComp) {
         this.leftPanelComp.signListComp.setSignList(object.index, this.typeName);
      }
   }

   /** เมื่อคลิกเปลี่ยน dropdown signer */
   onSignerChange($event) {
      this.signerSelected = $event;
      this._isChangeSigner = true;
      if (this._objDraw) {
         this._objDraw.attr('signer', this.signerSelected.signer.signerEmail.toLowerCase());
         this._objDraw.children()[0].fill(this.colors[this.signerSelected.index]);
         this.updateItemsSignCurrentPage();
      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         $objectDrag.attr('signer', this.signerSelected.signer.signerEmail.toLowerCase());
         $($objectDrag.children()[0]).attr('fill', this.colors[this.signerSelected.index]);
         this.updateItemsSignCurrentPage();
      }
   }

   /** ดึงรูปแบบความสูงของหน้า sign off */
   getHeight() {
      return 'height-sign';
   }

   /** หลังจากปิดหน้า sign off route ไปที่หน้า path ล่าสุดที่เข้ามาก่อนหน้านี้ */
   closePage() {
      const path = localStorage.getItem('url');
      const search = '/search';
      let param;
      if (path.startsWith(search)) {
         param = path.substring(path.indexOf('=') + 1);
         this.router.navigate([search], {queryParams: {q: param}});
         return;
      }
      this.router.navigate([localStorage.getItem('url')]);
      localStorage.removeItem('url');
   }

   onClickDelete(objItem) {
      this._onClickDelete = true;
      let id;
      const img = [];
      this.startDrawing = false;
      if (this._objDraw) {
         this._objDraw.selectize(false);
         id = $(this._objDraw.node).attr('id');
      }
      if (this._objDraw) {
         if (this._objectSVG) {
            for (const obj of this._objectSVG) {
               if (obj.svg) {
                  for (const item of obj.svg.children()) {
                     const idItem = $(item.node).attr('id');
                     if (idItem === id) {
                        item.remove();
                        this.setDeselectItem('');
                        this.finishSVG('');
                     }
                  }
               }
            }
         }
         this.updateItemsSignCurrentPage();
      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         this.setDeselectItem('');
         this.finishSVG('');
         $objectDrag.remove();
         this.updateItemsSignCurrentPage();
         if ($objectDrag.attr('class') === 'image') {
            img.push($objectDrag.attr('ref'));
            this.submitDeleteFile(img);
         }
      }
      this._onClickDelete = false;
   }

   onSelectPositionTypeChange(positionTypeValue) {
      let $imageCurrentPage, imgWidthCurrentPage, imgHeightCurrentPage, position, $objectDrag;
      if (this._objDraw) {
         $objectDrag = $(this._objDraw.node);
         this._objDraw.attr('positionType', positionTypeValue);
      } else if (this._objectDrag) {
         $objectDrag = $(this._objectDrag);
         $objectDrag.attr('positionType', positionTypeValue);
      }
      this.positionType = positionTypeValue;
      if (positionTypeValue !== 'CT' && $objectDrag) {
         $imageCurrentPage = this.findParentImageBySignItem($objectDrag);
         imgWidthCurrentPage = parseFloat($imageCurrentPage.attr('width'));
         imgHeightCurrentPage = parseFloat($imageCurrentPage.attr('height'));
         this.setSizeCurrentSignItem($objectDrag);
         position = this.calculatePosition(positionTypeValue, imgWidthCurrentPage, imgHeightCurrentPage);
         this.setPositionCurrentSignItem($objectDrag, position.coordinateX, position.coordinateY);
         const imgCurrentId = $objectDrag.parent().parent().attr('id');
         let heightTotal, scrollTop, scrollLeft;
         heightTotal = this.getTotalPageHeight(imgCurrentId);
         scrollTop = position.coordinateY + heightTotal - 200;
         scrollLeft = position.coordinateX;
         $('#sideNavContent').scrollTop(scrollTop);
         $('#sideNavContent').scrollLeft(scrollLeft);
      }
      if (this.taskAttribute.docList[this.currentIndex].signItems) {
         for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
            if (this._idSignitems === item.idSignItem) {
               item.positionType = positionTypeValue;
               if (position) {
                  item.coordinateX = position.coordinateX;
                  item.coordinateY = position.coordinateY;
               }
            }
         }
      }
   }

   onCheckboxIncludeChange(value) {
      this.chkName = value.chkName;
      this.chkDate = value.chkDate;
      this.chkApplyAll = value.chkApplyAll;

      if (!value.chkApplyAll) {
         let $objectDrag;

         if (this._objDraw) {
            $objectDrag = $(this._objDraw.node);
            this._objDraw.attr('chkName', value.chkName);
            this._objDraw.attr('chkDate', value.chkDate);
         } else if (this._objectDrag) {
            $objectDrag = $(this._objectDrag);
            $objectDrag.attr('chkName', value.chkName);
            $objectDrag.attr('chkDate', value.chkDate);
         }
         if (this.taskAttribute.docList[this.currentIndex].signItems) {
            for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
               if (item.fieldType === 'signature' && item.idSignItem === $objectDrag.attr('id')) {
                  item.chkName = value.chkName;
                  item.chkDate = value.chkDate;
               }
            }
         }
         this.editSignature($objectDrag,value.chkName,value.chkDate);
      } else {
         if (this.taskAttribute.docList[this.currentIndex].signItems) {
            for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
               if (item.fieldType === 'signature') {
                  let obj = $('#' + item.idSignItem);
                  item.chkName = value.chkName;
                  item.chkDate = value.chkDate;
                  obj.attr('chkName', value.chkName);
                  obj.attr('chkDate', value.chkDate);
                  this.editSignature(obj,value.chkName,value.chkDate);
               }
            }
         }
      }
   }

   onSelectFileuploadChange(files: any){
      const file = files;
      if (files.length === 0) {
         return;
      } else {
         this.uploadDoc(file);
      }
   }
   //**  render แสดงรูปภาพที่หน้าเอกสาร  */
   renderImage(files) {
      // generate a new FileReader object
      const reader = new FileReader();
      let orderSignIndex, objId, id, id_next;
      if (this._objDraw) {
         objId = this._objDraw.attr('id');
         id_next = $('#' + objId).next().attr('id');
         const reader = new FileReader();
         reader.readAsDataURL(files[0]);
         reader.onload = (e: any) => {
            let element = (<HTMLImageElement>document.getElementById(objId));
            this.itemImageId = element.getAttribute('ref');
            id = 'img_' + element.getAttribute('pageNum');
            let rect = (<HTMLImageElement>document.getElementById(id_next));
               for(const obj of this._objectSVG){
                  if(id===obj.id) {
                     this._draw = obj.svg;
                     break;
                  }
               }
               if (element.getAttribute('orderSignPage')) {
                  orderSignIndex = element.getAttribute('orderSignPage');
               }
               if(rect !== null){
                  element.parentNode.removeChild(element);  // ลบ tag <g> เพื่อเปลี่ยนเป็นรูปเป็น tag <image>
                  rect.remove();  /// ลบกรอบของ item
               } else {
                  element.parentNode.removeChild(element);  // ลบ tag <g> เพื่อเปลี่ยนเป็นรูปเป็น tag <image>
               }
               this.drawAttachImage(e, objId, orderSignIndex);
         };
      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         objId = $objectDrag.attr('id');
         const reader = new FileReader();
         reader.readAsDataURL(files[0]);
         reader.onload = (e: any) => {
            let element = (<HTMLImageElement>document.getElementById(objId));
            id = 'img_' + element.getAttribute('pageNum');
            this.itemImageId = element.getAttribute('ref');
            for (const obj of this._objectSVG) {
               if(id===obj.id) {
                  this._draw = obj.svg;
                  for (const item of obj.svg.children()) { /// ลบกรอบของ item กรณีที่มีการ Drag item
                     let rect = $(item.node);
                     if(rect.attr('fieldType') === undefined) {
                        if(rect.attr('class') === undefined) {
                           rect.remove();
                        }
                     }
                  }
                  break;
               }
            }
            if (element.getAttribute('orderSignPage')) {
               orderSignIndex = element.getAttribute('orderSignPage');
            }
               element.parentNode.removeChild(element); // ลบ tag <g> เพื่อเปลี่ยนเป็นรูปเป็น tag <image>
               this.drawAttachImage(e, element.id, orderSignIndex);
         };
      }
   }

   /// วาด image ขึ้นมาใหม่หลังจากมีการแก้ไขพร้อมตั้งค่าต่าง ๆ ให้กับ element
   drawAttachImage(e: any, id: string, pageSign: string){
      for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
         if(item.fieldType === 'image' && item.idSignItem === id) {
            this.startDrawing = true;
            this.setVisibleProperty(false);
            const ratioZoom = this.getCountZoom();
            let ratio = 0, maxWidth = 250, maxHeight = 250;
            this._objDraw = this._draw.image(e.target.result).loaded(function (loader) { // คำนวณ ratio รูปภาพให้ขนาด match กัน
               if (loader.width > maxWidth) { // Check if the current width is larger than the max
                  ratio = maxWidth / loader.width;
                  this.size(maxWidth * ratioZoom, (loader.height * ratio) * ratioZoom);
                  loader.height = loader.height * ratio;
                  loader.width = loader.width * ratio;
               } else if (loader.height > maxHeight) { // Check if current height is larger than max
                  ratio = maxHeight / loader.height;
                  this.size((loader.width * ratio) * ratioZoom, maxHeight * ratioZoom);
                  loader.width = loader.width * ratio;
                  loader.height = loader.height * ratio;
               }
               if (item) {
                  this.move((item.coordinateX), (item.coordinateY));
               }
            }).attr({
               'signer': this.service.user.email,
               'positionType': item.positionType,
               'pageType': item.pageType,
               'certId': item.certId,
               'cursor': 'pointer',
               'pageNum': item.pageNum,
               'order': item.order,
               'orderSignPage': pageSign,
               'fieldType': item.fieldType,
               'taskSignId': item.taskSignId,
               'isExists': item.isExists,
               'class': 'image',
               'stepOrder': item.stepOrder,
               'taskContactId': item.taskContactId
            });
            this.controllAttachImage(item);
            break;
         }
      }
   }

   /** ผูก image event ให้แต่ละ object */
   controllAttachImage(item){
      this._objDraw.on('load', (e) => { // โหลดรูปและคำนวณขอบกระดาษกรณี Draft ไว้มุมกระดาษ
         this.calculateOutBoundItemImage(e);
      });
      this._objDraw.on('beforedrag', (e) => {
         this.handleChangeTab();
         if (!this.isDrawing) {
            this._objDraw = ''; // เคลียร์ค่า object นี้ทิ้งเพื่อไม่ให้ซ้ำซ้อนตอนที่เก็บ object เข้า taskAttribute
         }
         this._objectDrag = e.target;
         const $id = e.target.id;
         this.deselectAllWithOutMatchId($id);
         if (this.taskAttribute.docList[this.currentIndex].signItems) {
            for (const signItem of this.taskAttribute.docList[this.currentIndex].signItems) {
               if (signItem.idSignItem === $id) {
                  this.setProperties(signItem, $id);
                  const index = this.leftPanelComp.toolsComp.signers.findIndex((data) => data.signerEmail.toLowerCase() === signItem.signer.toLowerCase());
                  this.leftPanelComp.toolsComp.selected = index;
                  this.isHideProperties = false;
                  this._isHideProp = false;
                  break;
               }
            }
         }
      });
      this._objDraw.on('beforedrag', function (e) {
         if (!item.flagSign) {
             if(this.type === 'image'){
               this.attr({'cursor': 'move'});
               this.selectize({
                  points: false,
                  rotationPoint: false
               });
            }
         }
      });
      this._objDraw.on('dragstart.namespace', (e) => {
         this._onDrag = true;
         onDrag = true;
         this._objectDrag = e.target; // เก็บ object drag ที่เลือกปัจจุบันล่าสุด
      });
      this._objDraw.on('dragmove.namespace', function (e) { // need to calculdate diffent Y
         if (changeImage) {
            e.preventDefault();
            this.move(e.detail.event.offsetX, e.detail.event.offsetY);
         }
      });
      this._objDraw.on('dragend.namespace', function (e) {
         if (typeName === 'sign' || typeName === 'signTask') {
            this.attr({'cursor': 'pointer'});
            if (this.type === 'image') {
               this.selectize({
                  points: ['lt', 'rt', 'rb', 'lb'],
                  rotationPoint: false
               }).resize({saveAspectRatio: true});
            } else {
               this.selectize({
                  points: false,
                  rotationPoint: false
               });
            }
         } else {
            this.attr({'cursor': 'pointer'});
            this.children()[0].attr({'cursor': 'pointer'});
            this.children()[1].attr({'cursor': 'pointer'});
            this.selectize({
               points: false,
               rotationPoint: false
            });
         }
         changeImage = false;
         onDrag = false;
      });
      this._objDraw.on('dragend.namespace', (e) => {
         this.isHideProperties = false;
         this._isHideProp = false;

         this.checkImgFocus(e);
         this._onDrag = false;
         this.isDrawing = false;
         this.calculateOutBoundItemImage(e);
         this.updateItemsSignCurrentPage();
         this.finishSVG('');
      });
      this._objDraw.on('resizing', (e) => {
         if (!this.isDrawing) {
            this._objDraw = '';
         }
         this._objectDrag = e.target;
      });
      this._objDraw.on('resizedone', (e) => {
         this.updateItemsSignCurrentPage();
      });
      this._objDraw.draggable();
      item.idSignItem = this._objDraw.attr('id');
      this._idSignitems = item.idSignItem;
      this.startDrawing = false;
   }

   //** upload file แนบรูปเอกสารบน Alfresco */
   uploadDoc(files: any) {
      const dateNow = moment(Date.now());
      const dateName = dateNow.format('yyyyMMDD_HHmmssSSS');
      if (this.validateFile(files)) {
         if (this.itemImageId === undefined || this.itemImageId === null) {
            this.itemImageId = undefined;
         }
          for (let i = 0; i < files.length; i++) {
            let typeName = "."+/[^/]*$/.exec(files[i].type)[0];
            files[i].fullPath = files[i].webkitRelativePath;
            files[i].fileName = dateName+typeName;
            this.init(i).subscribe(result => {
               const key = result.key;
               const fileNo = result.fileNo;
               let offset = 0;
               const file: any = files[i];
               const xhr = new XMLHttpRequest();
               const send = () => {
                  const end = Math.min(offset + this.chunkSize, file.size);
                  xhr.open('PUT', this.service.url + '/upload/' + result.key, true);
                  xhr.setRequestHeader('x-auth-token', this.service.user.token);
                  xhr.setRequestHeader('Content-Range', 'bytes ' + offset + '-' + (end - 1) + '/' + file.size);
                  const blob = file.slice.call(file, offset, end);
                  xhr.send(blob);
               };
               xhr.onload = () => {
                  if (xhr.status === 308) {
                     if (file.canceled) {
                        this.service.post('/cancel/upload/' + result.key, null).subscribe(() => {
                              // This is intentional.
                           },
                           (err) => {
                              console.error(err);
                           });
                        return;
                     }
                     offset += this.chunkSize;
                     send();
                  } else if (xhr.status === 201) {
                     this.finish(key, file, fileNo);
                  }
               };
               send();
            }, error => {
               files.error = error;
            });

            if (this.typeName === 'template') {
               break;
            }
         }
      }
   }

   finish(key: string, file: any, fileNo: any, dateName?: string) {
      const body = {
         name: file.fullPath || file.fileName,
         mimeType: file.type,
         id: this.itemImageId
      };
      // TODO body,fileNo, key
      this.service.uploadDocumentTemp("attachImage", body, fileNo, key).subscribe((response) => {
      const docId = response.docId;
      const img = (<HTMLImageElement>document.getElementById(this._idSignitems));
      img.setAttribute('ref', docId);
      }, error => {
         if (error.status === 413) {
            this.itemImageId.error = error.message;
         }
         if (error.status === 401) {

         }
      });
   }

      //** ลบไฟล์แนบเอกสาร */
   submitDeleteFile(array_file: string []) {
      if(array_file !== undefined || array_file.length >0){
         for (let i = 0; i < array_file.length; i++) {
            this.service.deleteDocument(array_file[i])
            .subscribe((response) => {
            },
            (err) => {
               console.error(err);
            });
         }
      }
   }

   private init(i: any): Observable<any> {
      return this.service.get('/init/upload/' + i);
   }

   validateFile(myFile: any) {
      for (let i = 0; i < myFile.length; i++) {
         if (myFile[i] != null) {
            this.ext = myFile[i].type;
            if (this.ext !== '') {
               if (this.validateExtension(this.ext) === false) {
                  this.handleToastError('uploadDoc.errorPdf');
                  return false;
               } else {
                  if (myFile[i].size > this.chunkSize) { // size 15120
                     this.handleToastError('registerSignature.errorFileSize');
                     return false;
                  } else {
                     this.renderImage(myFile);
                     return true;
                  }
               }
            } else {
               this.handleToastError('uploadDoc.errorPdf');
               return false;
            }
         }
      }
      return true;
   }

   handleToastError(key) {
      this.translate.get(key).subscribe((msg) => {
         this.toast.error(msg);
         this.handleChangeTab();
      });
   }

   validateExtension(v) {
      const allowedExtensions = new Array('image/png', 'image/jpeg', 'image/jpg', 'image/bmp');
      for (let ct = 0; ct < allowedExtensions.length; ct++) {
         const fileSelected = v.toLowerCase().lastIndexOf(allowedExtensions[ct]);
         if (fileSelected !== -1) {
            return true;
         }
      }
      return false;
   }

   onSelectPageTypeChange(value) {
      if (this._objDraw) {
         this._objDraw.attr('pageType', value);
      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         $objectDrag.attr('pageType', value);
      }
      this.pageType = value;
      if (this.taskAttribute.docList[this.currentIndex].signItems) {
         for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
            if (this._idSignitems === item.idSignItem) {
               item.pageType = value;
            }
         }
      }
   }

   /** หาว่า object ที่รับเข้ามานั้นอยู่ภายในหน้าไหนของเอกสาร */
   findParentImageBySignItem(objectSign) {
      const nameIdImage = 'img_';
      let idImage, isFound = false, $imageObject;
      do {
         objectSign = objectSign.parent();
         idImage = $(objectSign[0]).attr('id');
         isFound = idImage.includes(nameIdImage);
         if (isFound) {
            this.currentPageNo = idImage.split('_')[1];
         }
      } while (!isFound);
      $imageObject = $(objectSign.children()[0]);
      return $imageObject;
   }

   calculatePosition(positionType, width, height) {
      let x, y;
      switch (positionType) {
         case 'TL':
            x = 0;
            y = 0;
            break;
         case 'TR' :
            x = width - this.widthSignItem;
            y = 0;
            break;
         case 'MD' :
            x = (width / 2.0) - (this.widthSignItem / 2.0);
            y = (height / 2.0) - (this.heightSignItem / 2.0);
            break;
         case 'BL' :
            x = 0;
            y = height - this.heightSignItem;
            break;
         case 'BR' :
            x = width - this.widthSignItem;
            y = height - this.heightSignItem;
            break;
         default:

            break;
      }
      return {'coordinateX': x, 'coordinateY': y};
   }

   setPositionCurrentSignItem(groupSignItem, coordinateX, coordinateY) {
      if (groupSignItem.prop('tagName') === 'image') {
         groupSignItem.attr({'x': coordinateX, 'y': coordinateY});
      } else {
         groupSignItem.attr({'x': coordinateX, 'y': coordinateY});
         $(groupSignItem.children()[0]).attr({'x': coordinateX});
      }
   }

   setSizeCurrentSignItem(objectSign) {
      if ($(objectSign).attr('fieldType') === this._keyFieldType.signature || $(objectSign).attr('fieldType') === this._keyFieldType.initSignature) {
         this.widthSignItem = $(objectSign).attr('width');
         this.heightSignItem = $(objectSign).attr('height');
      } else {
         this.widthSignItem = $(objectSign).attr('width') * this.getCountZoom();
         this.heightSignItem = $(objectSign).attr('height') * this.getCountZoom();
      }
   }

   setProperties(item, id) {
      if (item.positionType) {
         this.positionType = item.positionType;
      } else {
         this.setInitialPositionType();
      }
      if (item.pageType) {
         this.pageType = item.pageType;
      } else {
         this.setInitialPageType();
      }
      if (!this.chkApplyAll) {
         this.chkName = item.chkName;
         this.chkDate = item.chkDate;
      } else {
         item.chkName = this.chkName;
         item.chkDate = this.chkDate;
         this.editSignature($('#' + id),this.chkName,this.chkDate);
      }
      this._idSignitems = id;

   }

   setInitialPositionType() {
      this.positionType = 'CT';
   }

   setInitialPageType() {
      this.pageType = 'CP';
   }

   onScroll($event) {
      const currentPage = $($(this.allImages.nativeElement.lastChild).children()[0]);
      const $parent = $($('#all-image').children()[this.page]);
      const $imageChild = $($parent.children()[0]);
      const $parent1 = $($('#all-image').children()[this.page - 1]);
      const $imageChild1 = $($parent1.children()[0]);
      const $parent2 = $($('#all-image').children()[this.page - 2]);
      const $imageChild2 = $($parent2.children()[0]);
      const $parent0 = $($('#all-image').children()[0]);
      const $imageChild0 = $($parent0.children()[0]);
      let scrollTop = $($event.target)[0].scrollTop;
      if (this.page === 1) {
         this.checkheightpage = (Number($imageChild1.attr('height')) + this._marginn) - 120;
      }
      if (this.checkheightpage < 400) {
         scrollTop = $($event.target)[0].scrollTop + 120;
      }
      if (this.getScrollDirection($event) === 'down') {
         if (this.page < this._dataPages[this.currentIndex].totalPages) {
            if (scrollTop > this.checkheightpage) {
               this.checkheightpage += Number($imageChild.attr('height')) + this._marginn;
               this.page++;
            }
         }
      } else {
         let height1, height2;
         if (this.page - 1 > 0) {
            height1 = Number($imageChild1.attr('height')) + this._marginn;
         }
         if (this.page - 2 > 0) {
            height2 = Number($imageChild2.attr('height')) + this._marginn;
         }
         const heightTotal = height1 + height2 * 2 / 3;
         if (scrollTop < this.checkheightpage - heightTotal) {
            this.checkheightpage -= Number($imageChild1.attr('height')) + this._marginn;
            this.page--;
         }
         if (this.page === 2) {
            if (scrollTop < Number($imageChild0.attr('height')) * 2 / 3) {
               this.page = 1;
            }
         }
      }
      if ($(this.allImages.nativeElement.lastChild).attr('id')) {
         const nextPageNo = parseInt($(this.allImages.nativeElement.lastChild).attr('id').split('_')[1], 10);
         const calculate = parseFloat(currentPage.attr('height')) + this._heightDialogShowPage * (nextPageNo - 1);
         if (this._heightDialogShowPage + scrollTop > calculate) {
            if (this._dataPages[this.currentIndex].totalPages > nextPageNo && !this._statusInitial[nextPageNo].isInitail) {
               this.addItemPage(this._dataPages[this.currentIndex], (nextPageNo));
            }
         }
      }
   }

   setTimeLoadThumbnail() {
      this.mytime = setTimeout(() => {
         this.onscrollTum.emit(this.page);
      }, 1000);
   }

   /** add หน้าของเอกสารลงตาม items และ หน้า ที่รับเข้ามา */
   addItemPage(items, pageNo) {
      if (!items?.pages?.[pageNo]) { // เอกสารยังแปลงไม่เสร็จ/แปลงไม่ได้ ไม่มีข้อมูลหน้า
         return;
      }
      const token = this.service.user.token;
      const item = items.pages[pageNo];
      this.imgUrl = this.service.url + '/document/' + items.docId + '/' + item.pageNo + '?token=' + token + '&lastmodify=' + Date.now();
      this.append(this.imgUrl, item.width, item.height, this.transformHeight, item.pageNo, this.maxWidth);
      const imgID = 'img_' + item.pageNo;
      this.transformHeight += item.height + this._margin;
      this._objectSVG.push({'id': imgID, 'pageNo': item.pageNo, 'svg': SVG(imgID), 'docId': items.docId});
      this._statusInitial[pageNo].isInitial = true;
   }

   addItemPagePrint(items, pageNo) {
      const token = this.service.user.token;
      const item = items.pages[pageNo];
      this.imgUrl = this.service.url + '/document/' + items.docId + '/' + item.pageNo + '?token=' + token + '&lastmodify=' + Date.now();
      this.appendPrint(this.imgUrl, item.width * this.zoomRatio,
         item.height * this.zoomRatio, this.transformHeight * this.zoomRatio, item.pageNo);
   }

   appendPrint(imgUrl: string, width: number, height: number, tranHeight: number, pageNo: number) {
      if (pageNo === 1) {
         this.numprint = 20;
      } else {
         this.numprint = 25;
      }
      this.print.nativeElement
         .insertAdjacentHTML('beforeEnd',
            '<img src=' + imgUrl + ' width=' + '100%' + ' height=' + '170%' + ' ' +
            'style="padding-top:' + this.numprint + 'px" class="marginprint">'
         );
   }

   getTotalPageHeight(id) {
      let heightTotal;
      heightTotal = parseFloat($('#' + id).attr('transform').split(',')[5].replace(')', ''));
      return heightTotal;
   }

   getPageHeight(id) {
      return parseFloat($('#' + id).find('image').attr('height'));
   }

   handleWaitActionPrint(isShow) {
      if (isShow) {
         $('#pano-sign-task').show();
         $('#main-page').addClass('blur');
      } else {
         $('#pano-sign-task').hide();
         $('#main-page').removeClass('blur');
      }
   }

   calculatePageHeightMargin(id) {
      let heightTotal = 0;
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (id === object.id) {
               break;
            } else {
               heightTotal += parseFloat($('#' + object.id).find('image').attr('height')) + this._margin * this.getCountZoom();
            }
         }
      }
      return heightTotal;
   }

   calculateScrollCenter(coordinateY, id) {
      if (coordinateY >= this.getPageHeight(id) / 2) {
         coordinateY = coordinateY - this.getPageHeight(id) / 2;
      } else {
         coordinateY = 0;
      }
      return coordinateY;
   }

   findImageParent(target) {
      let next, count = 0;
      const maxIterations = 3;
      while (!$(target).hasClass('imageSign')) {
         next = $(target).parent();
         target = next[0];
         count++;
         if (count >= maxIterations) {
            break;
         }
      }
      return $(target).find('image')[0];
   }

   findParentByClassName(target, key) {
      let next, count = 0;
      while (!$(target).hasClass(key)) {
         next = $(target).parent();
         target = next[0];
         count++;
      }
      return $(target);
   }

   setOutPage($event) {
      this._moveOnPage = false;
      if(!this._objDraw){
         this.isDrawing = false;
      }
   }

   onDragOver($event) {
      $event.preventDefault();
      $event.stopPropagation();
      this.startDrawing = true;
      if (!this._isDrag) {
         this._isDrag = true;
         this.deselectAll();
      }
      if(!this._objDraw){
         this.isDrawing = false;
      }
   }

   onDragOverDisable($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $event.dataTransfer.effectAllowed = 'none';
      $event.dataTransfer.dropEffect = 'none';
   }

   onDrop($event) {
      switch (this._fieldType) {
         case this._keyFieldType.signature:
            if (!this.hasSignature) {
               this.openUpdateSignatureDraw(undefined, this.initialId, this._fName + ' ' + this._lName, $event);
               this._flagMouseOver = true;
            } else {
               this.drawSVG($event);
               this._isDrag = false;
               this.startDrawing = false;
               $event.preventDefault();
               $event.stopPropagation();
            }
            break;
         case this._keyFieldType.initSignature:
            if (!this.hasSignature) {
               this.openUpdateSignatureDraw(this.signatureId, undefined, this._fName + ' ' + this._lName, $event);
               this._flagMouseOver = true;
            } else {
               this.drawSVG($event);
               this._isDrag = false;
               this.startDrawing = false;
               $event.preventDefault();
               $event.stopPropagation();
            }
            break;
         case this._keyFieldType.name:
         case this._keyFieldType.date:
         case this._keyFieldType.text:
         case this._keyFieldType.image:
         case this._keyFieldType.checkbox:
            this.drawSVG($event);
            this._isDrag = false;
            this.startDrawing = false;
            $event.preventDefault();
            $event.stopPropagation();
            break;
         default:
            break;
      }
   }

   onMouseOver($event) {
      switch (this._fieldType) {
         case this._keyFieldType.signature:
            if (this.startDrawing) {
               if (!this.hasSignature) {
                  if (!this._flagMouseOver) {
                     this.openUpdateSignatureDraw(undefined, this._initialize, this._fName + ' ' + this._lName, $event);
                     this._flagMouseOver = true;
                  }
               } else {
                  this.drawSVG($event);
               }
            }
            break;
         case this._keyFieldType.initSignature:
            if (this.startDrawing) {
               if (!this.hasSignature) {
                  if (!this._flagMouseOver) {
                     this.openUpdateSignatureDraw(this.signatureId, undefined, this._fName + ' ' + this._lName, $event);
                     this._flagMouseOver = true;
                  }
               } else {
                  this.drawSVG($event);
               }
            }
            break;
         case this._keyFieldType.name:
         case this._keyFieldType.date:
         case this._keyFieldType.text:
         case this._keyFieldType.image:
         case this._keyFieldType.checkbox:
            this.drawSVG($event);
            break;
         default:
            break;
      }
   }

   handleToastErrorWithKey(key) {
      this.translate.get(key).subscribe((msg) => {
         this.toast.error(msg);
         this.handleChangeTab();
         this.leftPanelComp.selectedTab = 1;
      });
   }

   handleGetTranslateSignItem() {
      this.translate.get('signTools').subscribe((msg) => {
         this._signature = msg.signature;
         this._initialize = msg.initSignature;
         this._fullName = msg.nameItem;
         this._date = msg.dateItem;
         this._text = msg.textItem;
         this._image = msg.imageItem;
      });
   }

   handleChangeTab() {
      this.leftPanelComp.selectedTab = 1;
   }

   handleMovePageLeftWithMenu($event) {
      if ($event !== 1) {
         this.deselectAll();
         this.setVisibleProperty(false);
      }
   }

   handleToggleOpend() {
      $('#sideNavContent').animate({
         marginLeft: '0px'
      }, 100);
   }

   handleToggleClosed() {
      $('#sideNavContent').animate({
         marginLeft: '250px'
      }, 100);

   }

   handleFitPage(isToggleOpen) {
      if (isToggleOpen) {
         if (!this.isZoom && this.countZoom < 4) {
            this.zoomRatio = 2.0;
            this.ZoomPage(true, this.zoomRatio);
         }
      } else {
         if (this.countZoom !== 0) {
            this.ZoomPage(false, this.zoomRatio);
            this.zoomRatio = 2.0;
         }
      }
   }

   handleCheckLanguage() {
      this.translate.get('langCurrent').subscribe((msg) => {
         if (msg === 'th') {
            this._widthSignature = 24;
            this._widthInitSignature = 27;
            this._widthInitName = 26;
            this._widthInitDate = 42;
            this._heightInitNameDate = 13;
            this._y = 0;
            this._fontSize = 9;
         }
      });
   }

   onZoomIn($event) {
      if (this.countZoom < 4) {
         this.checkheightpage = this.checkheightpage * 2;
         this.isZoom = true;
         this.ZoomPage(true, 2.0);
         if (!this.isDrawing) {
            if (this._objDraw) {
               this._objectDrag = this._objDraw.node;
            }
            this._objDraw = '';
         }
         this.updateItemsSignCurrentPage();
      }
   }

   onZoomOut($event) {
      if (this.countZoom > 0) {
         this.checkheightpage = this.checkheightpage / 2;
         this.ZoomPage(false, 2.0);
         if (!this.isDrawing) {
            if (this._objDraw) {
               this._objectDrag = this._objDraw.node;
            }
            this._objDraw = '';
         }
         this.updateItemsSignCurrentPage();
      }
   }

   /** เมื่อมีการทำ action zoom page */
   ZoomPage(isZoomIn, ratio) {
      if (this.countZoom >= 0 || this.countZoom <= 4) {
         this.ZoomContainerImage(isZoomIn, ratio);
         const $sideNavContent = $('#sideNavContent');
         if (isZoomIn) {
            this.ZoomItemAll(true, ratio);
            this.setHeightObject($('#svg-page'), $('#svg-page').attr('height') * ratio);
            this.setWidthObject($('#svg-page'), $('#svg-page').attr('width') * ratio);
            this.countZoom += 2;
            if (this.countZoom === 4) {
               this.viewDocumentComp.canZoomIn = false;
            } else {
               this.viewDocumentComp.canZoomOut = true;
            }
            $sideNavContent.scrollTop($sideNavContent.scrollTop() * ratio);
         } else {
            $sideNavContent.scrollTop($sideNavContent.scrollTop() / ratio);
            this.ZoomItemAll(false, ratio);
            this.setHeightObject($('#svg-page'), $('#svg-page').attr('height') / ratio);
            this.setWidthObject($('#svg-page'), $('#svg-page').attr('width') / ratio);
            this.countZoom -= 2;
            if (this.countZoom === 0) {
               this.viewDocumentComp.canZoomOut = false;
               this.isZoom = false;
            } else {
               this.viewDocumentComp.canZoomIn = true;
            }
         }
      }
   }

   /** ทำการ zoom ทุก object ที่แสดงอยู่ */
   ZoomItemAll(isZoomIn, ratio) {
      if (this._objectSVG) {
         for (const obj of this._objectSVG) {
            if (obj.svg) {
               for (const item of obj.svg.children()) {
                  this.zoomItem(item, isZoomIn, ratio);
               }
            }
         }
      }
   }

   zoomItem(item, isZoomIn, ratio) {
      const width = item.attr('width');
      const height = item.attr('height');
      const x = item.attr('x');
      const y = item.attr('y');
      if (item.type === 'g' && item.attr('class') === 'signature' || item.type === 'g' && item.attr('class') === 'initSignature') {
         const wRectChild = item.children()[0].attr('width');
         const hRectChild = item.children()[0].attr('height');
         const xText = item.children()[1].attr('x');
         const yText = item.children()[1].attr('y');
         const fontSize = item.children()[1].attr('font-size');
         item.attr('transform', this.ZoomTransform(isZoomIn, item, ratio));
         if (isZoomIn) {
            item.attr('x', x * ratio);
            item.attr('y', y * ratio);
            item.children()[0].attr('width', wRectChild * ratio);
            item.children()[0].attr('height', hRectChild * ratio);
            item.children()[1].attr('x', xText * ratio);
            item.children()[1].attr('y', yText * ratio);
            item.children()[1].attr('font-size', fontSize * ratio);
         } else {
            item.attr('x', x / ratio);
            item.attr('y', y / ratio);
            item.children()[0].attr('width', wRectChild / ratio);
            item.children()[0].attr('height', hRectChild / ratio);
            item.children()[1].attr('x', xText / ratio);
            item.children()[1].attr('y', yText / ratio);
            item.children()[1].attr('font-size', fontSize / ratio);
         }
      } else if (item.type === 'image') {
         if (isZoomIn) {
            item.attr('width', width * ratio);
            item.attr('height', height * ratio);
            item.attr('x', x * ratio);
            item.attr('y', y * ratio);
         } else {
            item.attr('width', width / ratio);
            item.attr('height', height / ratio);
            item.attr('x', x / ratio);
            item.attr('y', y / ratio);
         }
      } else if (item.type === 'text') {
         const fontSize = item.attr('font-size');
         if (isZoomIn) {
            item.attr('x', x * ratio);
            item.attr('y', y * ratio);
            item.attr('font-size', fontSize * ratio);
            if (item.attr('class') === 'text') {
               const fontSizeTspan = parseFloat(item.node.lastChild.style.fontSize);
               item.node.lastChild.style.fontSize = (fontSizeTspan * ratio) + 'px';
            }
         } else {
            item.attr('x', x / ratio);
            item.attr('y', y / ratio);
            item.attr('font-size', fontSize / ratio);
            if (item.attr('class') === 'text') {
               const fontSizeTspan = parseFloat(item.node.lastChild.style.fontSize);
               item.node.lastChild.style.fontSize = (fontSizeTspan / ratio) + 'px';
            }
         }
      } else if ((item.type === 'g') && (item.attr('class') === 'checkbox')) {
         const wRectChild = item.children()[0].attr('width');
         const hRectChild = item.children()[0].attr('height');
         const wRectChild1 = item.children()[1].attr('width');
         const hRectChild1 = item.children()[1].attr('height');
         const wRectChild2 = item.children()[2].attr('width');
         const hRectChild2 = item.children()[2].attr('height');
         const xBox = item.children()[1].attr('x');
         const yBox = item.children()[1].attr('y');
         const xCheck = item.children()[2].attr('x');
         const yCheck = item.children()[2].attr('y');
         item.attr('transform', this.ZoomTransform(isZoomIn, item, ratio));
         if (isZoomIn) {
            item.attr('width', width * ratio);
            item.attr('height', height * ratio);
            item.attr('x', x * ratio);
            item.attr('y', y * ratio);
            item.children()[0].attr('width', wRectChild * ratio);
            item.children()[0].attr('height', hRectChild * ratio);
            item.children()[1].attr('x', xBox * ratio);
            item.children()[1].attr('y', yBox * ratio);
            item.children()[1].attr('width', wRectChild1 * ratio);
            item.children()[1].attr('height', hRectChild1 * ratio);
            item.children()[2].attr('x', xCheck * ratio);
            item.children()[2].attr('y', yCheck * ratio);
            item.children()[2].attr('width', wRectChild2 * ratio);
            item.children()[2].attr('height', hRectChild2 * ratio);
         } else {
            item.attr('width', width / ratio);
            item.attr('height', height / ratio);
            item.attr('x', x / ratio);
            item.attr('y', y / ratio);
            item.children()[0].attr('width', wRectChild / ratio);
            item.children()[0].attr('height', hRectChild / ratio);
            item.children()[1].attr('x', xBox / ratio);
            item.children()[1].attr('y', yBox / ratio);
            item.children()[1].attr('width', wRectChild1 / ratio);
            item.children()[1].attr('height', hRectChild1 / ratio);
            item.children()[2].attr('x', xCheck / ratio);
            item.children()[2].attr('y', yCheck / ratio);
            item.children()[2].attr('width', wRectChild2 / ratio);
            item.children()[2].attr('height', hRectChild2 / ratio);
         }
      }
   }

   ZoomContainerImage(isZoomIn, ratio) {
      for (let i = 0; i < $('#all-image').children().length; i++) {
         const $parent = $($('#all-image').children()[i]);
         const $imageChild = $($parent.children()[0]);
         const $textChild = $($parent.children()[1]);
         const $textWatermark = $($parent.children()[2]);
         const pageNo = parseInt($parent.attr('id').split('_'), 10);
         $($('#all-image').children()[i]).attr('transform', this.ZoomTransform(isZoomIn, $($('#all-image').children()[i]), ratio));
         if (isZoomIn) {
            this.setHeightObject($imageChild, $imageChild.attr('height') * ratio);
            this.setWidthObject($imageChild, $imageChild.attr('width') * ratio);
         } else {
            this.setHeightObject($imageChild, $imageChild.attr('height') / ratio);
            this.setWidthObject($imageChild, $imageChild.attr('width') / ratio);
         }
         this.setXobject($textChild, this.calculateXtext($imageChild.attr('width'), pageNo, this._totalPages));
         this.setYobject($textChild, this.calculateYtext(parseFloat($imageChild.attr('height'))));

         if ($textWatermark) {
            let fontSize = Number($textWatermark.attr('font-size'));
            let transform = $textWatermark.attr('transform');
            if (transform) {
               const strNum = transform?.replace('translate(', '')?.replace(')', '')?.replace(' rotate(-45)', '').split(',');
               let x = Number(strNum[0]);
               let y = Number(strNum[1]);
               if (isZoomIn) {
                  fontSize = fontSize * ratio;
                  x = x * ratio;
                  y = y * ratio;
               } else {
                  fontSize = fontSize / ratio;
                  x = x / ratio;
                  y = y / ratio;
               }
               transform = 'translate(' + x + ',' + y + ') rotate(-45)';
               $textWatermark.attr('font-size', fontSize);
               $textWatermark.attr('transform', transform);
            }
         }
      }
   }

   /** get value from attribute transform from tag image and calculate zoompage */
   ZoomTransform(isZoomIn, $object, translateY) {
      const matrix = this.getValueTransform($object.attr('transform'));
      if (translateY !== -1) {
         if (isZoomIn) {
            matrix[4] = matrix[4] * translateY;
            matrix[5] = matrix[5] * translateY;
         } else {
            matrix[4] = matrix[4] / translateY;
            matrix[5] = matrix[5] / translateY;
         }
      }
      return 'matrix(' + matrix.toString() + ')';
   }

   getValueTransform(value) {
      const transform = value.replace(/[^0-9\-.,]/g, '').split(','); // split get only value matrix(0,0,0,0,0,0) => array
      const matrix = [];
      for (let i = 0; i < transform.length; i++) {
         matrix[i] = parseFloat(transform[i]);
      }
      return matrix;
   }

   setHeightObject($object, height) {
      $object.attr('height', height);
   }

   setWidthObject($object, width) {
      $object.attr('width', width);
   }

   setXobject($object, x) {
      $object.attr('x', x);
   }

   setYobject($object, y) {
      $object.attr('y', y);
   }

   setHeaderWidth(width) {
      $('.viewdoc-toolbar').css('padding-left', width);
   }

   setFontSignText() {
      const objElement = document.getElementsByTagName('tspan');

      for (let i = 0; i < objElement.length; i++) {
         if (objElement[i].parentElement.getAttribute('class') !== this._keyFieldType.text) {
            objElement[i].style.fontFamily = 'THSarabunNew';
         }
      }
   }

   calculateXtext(width, pageNo, pageTotal) {
      return width - this.calculateLenStr(this.getLenNumber(pageNo), this.getLenNumber(pageTotal));
   }

   calculateYtext(height) {
      return height + 15;
   }

   removeArrByValue(arr, element) {
      let index = 0;
      while (true) {
         if (index > arr.length - 1) {
            break;
         }
         if (arr[index].signer !== element) {
            arr.splice(index, 1);
         } else {
            index++;
         }
      }
      return arr;
   }

   setVisibleProperty(isShow) {
      this.leftPanelComp.visiblityState = isShow;
   }

   getDrawerOpen() {
      return this.drawer.opened;
   }

   calculateLenStr(strlen1, strlen2) {
      return 20 + (strlen1 * 8) + (strlen2 * 8);
   }

   calculateLenStrSign(str) {
      const widthChar = 5;
      let len = 0;
      for (let i = 0; i < str.length; i++) {
         if ((str[i] === 'ำ' || str[i] === 'ณ' || str[i] === 'ฏ' || str[i] === 'ฐ')) {
            len += 5.3;
         } else if ((str[i] >= 'a' && str[i] <= 'z') || (str[i] >= 'A' && str[i] <= 'Z')
            || (str[i] >= '0' && str[i] <= '9') || (str[i] === '/')
            || (str[i] >= 'ก' && str[i] <= 'ฮ') || (str[i] >= 'เ' && str[i] <= 'ๆ')
            || (str[i] === 'ะ') || (str[i] === ' ') || str[i] >= 'า' && str[i] <= 'ำ') {
            len += widthChar;
         }
      }
      return len;
   }

   checkThaiLanguage(str) {
      let isThai = false;
      for (let i = 0; i < str.length; i++) {
         if ((str[i] >= 'ก' && str[i] <= 'ฮ') || (str[i] >= 'เ' && str[i] <= 'ๆ') || (str[i] === 'ะ') || str[i] >= 'า' && str[i] <= 'ำ') {
            isThai = true;
            break;
         }
      }
      return isThai;
   }

   getLenNumber(number) {
      return number.toString().length;
   }

   getImageWidth(id) {
      const childImg = $('#' + id).children()[0];
      return $(childImg).attr('width');
   }

   getProfile() {
      this.service.getProfile()
         .subscribe((data: any) => {
            this.hasSignature = data.hasSignature;
            this.hasInitial = data.hasInitial;
            this.signatureId = data.signatureId;
            this.initialId = data.initialId;
            this.includeName = data.includeName;
            this.includeDate = data.includeDate;
            this.leftPanelComp.hasSignature = data.hasSignature;
            this.leftPanelComp.hasInitial = data.hasInitial;
            this._fName = data.fName;
            this._lName = data.lName;
            this._isTwofacGoogle = data.isTwoFactorSignGoogle;
            this._isTwofacSign = data.isTwoFactorSign;
            this._isFirstSingIn = data.isFirstLogin;
            this.leftPanelComp.profile = data;
            if (this._isFirstSingIn) {
               this.openChangePassword();
            }
         });
   }

   /** เมื่อทำการเซ็น ส่งข้อมูลไปให้ service */
   actionSignOff(btnSigned: any) {
      btnSigned.disabled = true;
      this._signObjects = [];
      this._docListItem = [];
      this._docList = [];
      // ตรวจสอบว่าผู้ลงนาม มี Certificate ของ site นี้แล้วหรือยัง
      let isCheckcert = false;
      if (this.certificateList !== null){
         if (this.certificateList.length > 0){
            for (let i = 0; i < this.certificateList.length; i++){
               if (this.tin === this.myFiles){
                  if (this.certificateList[i].certType==='PSN'){
                        isCheckcert = true;
                        this.certId = this.certList[2];
                        this.siteId = this.tin;
                        break;
                  }
               } else {
                  if (this.certificateList[i].certType==='ORG'){
                     if (this.tin===this.certificateList[i].objectName){
                        isCheckcert = true;
                        this.certId = this.certList[1];
                        this.siteId = this.certificateList[i].objectName;
                        break;
                     }
                  }
               }
            }
         }
      }

      if (isCheckcert === false){
         if(this.tin === this.myFiles){
            this.siteId = this.myFiles;
         }
         this.siteId = this.tin;
         this.certId = this.certList[0];
      }

      this.addItemsSign();
      this.setDocListItem(this.docId, this._totalPages, this._signObjects, this.siteId, this.certId, this.tempId);
      // TODO change to set taskAttribute.docList
      this._docList.push(this._docListItem);
      let isHaveSigned = false;
      for (let i = 0; i < this._docList.length; i++) {
         if (this._docList[i].signItems !== undefined && this._docList[i].signItems.length > 0
            && this.searchSignature(this._docList[i].signItems)) {
            isHaveSigned = true;
            break;
         }
      }

      if (isHaveSigned) {
         this.service.getProfile()
            .subscribe((data: any) => {
               if (data.hasSignature || data.hasInitial) {
                  this.validateTwoFactor(btnSigned, data.isTwoFactorSign, data.isTwoFactorSignGoogle);
               } else {
                  this.openUpdateSignature(data.signatureId, data.initialId, data.fName + ' ' +
                     data.lName, btnSigned, data.isTwoFactorSign, data.isTwoFactorSignGoogle);
               }
            }, error => {
               btnSigned.disabled = false;
               console.error(error);
            });
      } else {
         btnSigned.disabled = false;
         this.handleToastError('signDoc.errorNoSign');
      }
   }

   /** เปิด diglog เพื่อให้ตั้งค่าลายเซ็น */
   openUpdateSignature(signatureId: any, initialId: any, fullName: any, btnSigned: any, isTwoFacSign: any, isTwoFactorSignGoogle: boolean) {
      this.setDialogRegistSignature(signatureId, initialId, fullName);
      this.registerSignDialog.afterClosed().subscribe(result => {
         if (result) {
            this.service.getProfile()
               .subscribe((data: any) => {
                  this.hasSignature = data.hasSignature;
                  this.hasInitial = data.hasInitial;
               });
            this.validateTwoFactor(btnSigned, isTwoFacSign, isTwoFactorSignGoogle);
         } else {
            btnSigned.disabled = false;
         }
      });
   }

   setDialogRegistSignature(signatureId: any, initialId: any, fullName: any) {
      this.registerSignDialog = this.dialog.open(RegisterSignatureComponent, {
         disableClose: true,
         data: this
      });
      this.registerSignDialog.componentInstance.signatureId = signatureId;
      this.registerSignDialog.componentInstance.initialId = initialId;
      this.registerSignDialog.componentInstance.includeName = this.includeName;
      this.registerSignDialog.componentInstance.includeDate = this.includeDate;
      if (!this.hasSignature) {
         this.registerSignDialog.componentInstance.registerInitialize = true;
         this.registerSignDialog.componentInstance.imageSignatureOriginal = 'assets/images/no_signature.png';
      } else {
         this.registerSignDialog.componentInstance.imageSignatureOriginal = this.picSign;
      }

      if (!this.hasInitial) {
         this.registerSignDialog.componentInstance.registerSignature = true;
         this.registerSignDialog.componentInstance.imageInitOriginal = 'assets/images/no_initials.png';
      } else {
         this.registerSignDialog.componentInstance.imageInitOriginal = this.picInitSign;
      }
      this.registerSignDialog.componentInstance.fullNameValue = fullName;
   }

   setUpdateSignature(event) {
      this.hasSignature = event;
   }

   setUpdateInitial(event) {
      this.hasInitial = event;
   }

   /** เปิด dialog twofactor authen */
   validateTwoFactor(btnSigned: any, isTwoFacSign: any, isTwoFactorSignGoogle: boolean) {
      this.handleLoadPage(true);
      this.addItemSign(this.currentIndex);
      this.revertDataToNormalSize(this._docList, this.isZoom);
      this.service.signDocument(0, this._docList, '', null) // เช็ค 2FA ที่ service signdoc
         .subscribe((response) => {
            this.signCompleted(btnSigned, response);
         }, (error) => {
            if(error.status === this.STATUS_2FA) {
               this.openTwoFactor(btnSigned, isTwoFacSign, isTwoFactorSignGoogle, error);
            } else {
               this.handleLoadPage(false);
               btnSigned.disabled = false;
            }
         });
   }

   openTwoFactor(btnSigned: any, isTwoFacSign: any, isTwoFactorSignGoogle: boolean, error: any) {
      this.twofactor = this.dialog.open(TwofactorComponent, {
         disableClose: true,
         data: {
            token: null,
            mode: 'sign',
            message: error.error,
            isTwoFactorSignGoogle: isTwoFactorSignGoogle,
            body: { taskId: '0', data: this._docList, password: '', taskForm: null }
         }
      });
      this.twofactor.afterClosed().subscribe(response => {
         if (response) {
            this.signCompleted(btnSigned, response);
         } else {
            this.handleLoadPage(false);
            btnSigned.disabled = false;
         }
      });
   }

   signCompleted(btnSigned: any, response: any) {
      this.fnSaveDoc();
      this.fnRemoveFileTemp();
      btnSigned.disabled = false;
      this.handleLoadPage(false);
      this.validateImage(this._docList[0].docId);
      this.toast.success(response);
      this.closePage();
   }

   validateImage(docId: string){
      let array_file = [];
      if(docId){
         for (let i = 0; i < this.taskAttribute.docList.length; i++){
            if(docId===this.taskAttribute.docList[i].docId){
               if (this.taskAttribute.docList[i].signItems !== undefined && this.taskAttribute.docList[i].signItems.length > 0) {
                  for (let j = 0; j < this.taskAttribute.docList[i].signItems.length; j++) {
                      if(this.taskAttribute.docList[i].signItems[j].idImageItem !== undefined){
                        array_file.push(this.taskAttribute.docList[i].signItems[j].idImageItem);
                      }
                  }
               }
            }
         }
         this.submitDeleteFile(array_file);
      }
   }

   fnSaveDoc() {
      this.service.getAnnotation(this._docList[0].docId, true).subscribe(data => {
         if (data !== null) {
            this.service.insertDataToDatabase(this._docList[0].docId, data.annotationId, data.annotationVersion, data.createdBy).subscribe( () => {});
         }
      });
   }
   fnRemoveFileTemp() {
      if (this.tempId) {
         this.service.deleteDocument(this.tempId).subscribe(() => {});
      }
   }

   searchSignature(arr) {
      let flag = false;
      arr.forEach((val, index) => {
         if (val.fieldType === this._keyFieldType.signature || val.fieldType === this._keyFieldType.initSignature || val.fieldType === this._keyFieldType.image) {
            flag = true;
            return;
         }
      });
      return flag;
   }

   handleLoadPage(active) {
      this.actionLoad.emit(active);
   }

   /** ตั้งค่า tutorial ในหน้านี้ */
   onStartTutorial(): void {
      if (!this._isFirstSingIn) {
         const isHideSigner = this.leftPanelComp.isHideSigner;
         enjoyhint_instance = new EnjoyHint({});
         let enjoyhint_script_steps = [];
         let hintMsg_M: any;
         hintMsg_M = new Map<string, string>();
         this.translate.get('tutorial').subscribe((msg) => {
            setTimeout(() => {
               hintMsg_M.set('next', msg.next);
               hintMsg_M.set('close', msg.close);
               hintMsg_M.set('documentBar', msg.signOff.documentBar);
               hintMsg_M.set('toolsBar', msg.signOff.toolsBar);
               hintMsg_M.set('signBar', msg.signOff.signBar);
               hintMsg_M.set('toolsOption', msg.signOff.toolsOption);
               hintMsg_M.set('action', msg.signOff.action);
               hintMsg_M.set('sign', msg.signOff.sign);
               hintMsg_M.set('actionSignOff', msg.signOff.actionSignOff);
               if (isHideSigner) {
                  enjoyhint_script_steps = [
                     {
                        'next .mat-tab-label.mat-ripple.ng-star-inserted:eq(0)': hintMsg_M.get('documentBar'),
                        'nextButton': {text: hintMsg_M.get('next')},
                        'skipButton': {text: hintMsg_M.get('close')},
                     },
                     {
                        'click .mat-tab-label.mat-ripple.ng-star-inserted:eq(1)': hintMsg_M.get('toolsBar'),
                        'nextButton': {text: hintMsg_M.get('next')},
                        'skipButton': {text: hintMsg_M.get('close')},
                     },
                     {
                        'next #tools-menu-hint': hintMsg_M.get('toolsOption'),
                        'nextButton': {text: hintMsg_M.get('next')},
                        'skipButton': {text: hintMsg_M.get('close')},
                        'left': -20,
                        'right': 40
                     },
                  ];
               } else {
                  enjoyhint_script_steps = [
                     {
                        'next .mat-tab-label.mat-ripple.ng-star-inserted:eq(0)': hintMsg_M.get('documentBar'),
                        'nextButton': {text: hintMsg_M.get('next')},
                        'skipButton': {text: hintMsg_M.get('close')},
                     },
                     {
                        'next .mat-tab-label.mat-ripple.ng-star-inserted:eq(1)': hintMsg_M.get('signBar'),
                        'nextButton': {text: hintMsg_M.get('next')},
                        'skipButton': {text: hintMsg_M.get('close')},
                     },
                  ];
               }
               if (isHideSigner) {
                  enjoyhint_script_steps.push({
                     'next #action-hint': hintMsg_M.get('actionSignOff'),
                     'nextButton': {text: hintMsg_M.get('next')},
                     'skipButton': {text: hintMsg_M.get('close')},
                  });
               }
               const lengthStep = enjoyhint_script_steps.length - 1;
               enjoyhint_script_steps[lengthStep].nextButton = {'text': hintMsg_M.get('close')};
               enjoyhint_script_steps[lengthStep].showSkip = false;
               enjoyhint_instance.set(enjoyhint_script_steps);
               enjoyhint_instance.run();
            }, 500);
         });
      }
   }

   onPrint($event) {
      if (this.isClickPage) {
         if (document.getElementById('print')) {
            $('#print').empty();
         }
      }
      if (!this.isLoopPage) {
         for (let i = 0; i < this._dataPages[this.currentIndex].totalPages; i++) {
            if (!this._statusInitial[i].isInitail) {
               this.addItemPagePrint(this._dataPages[this.currentIndex], i);
            }
         }
         this.isClickPage = false;
         this.isLoopPage = true;
      }
      const divToPrint = document.getElementById('print').innerHTML;
      const newWindow = window.frames['prints'];
      newWindow.document.write(`
          <html>
              <head>
                <title></title>
               <style >

              /*html{*/
              /*max-height: 400%;*/
              /*background-color: #fff;*/
              /*}     */
                </style>
                <script>
                 function printt(){
                    window.print();
                    window.close();
                 };
               </script>
              </head >
              <body onload="printt();">
              ${divToPrint}
              </body>
            </html>
          `);

      newWindow.document.close();
   }

   getCountZoom() {
      return this.countZoom === 0 ? 1 : this.countZoom;
   }

   getScrollDirection($event) {
      const scrollTop = $($event.target)[0].scrollTop;
      if (this.giveScroll < scrollTop) {
         this.giveScroll = scrollTop;
         return 'down';
      } else {
         this.giveScroll = scrollTop;
         return 'up';
      }
   }

   onDownload(docId) {
      window.open(this.service.url + '/downloadAdmin?id=' + docId + '&token=' + this.service.user.token, '_blank');
   }

   /** แปลงค่า signitem กลับเป็นขนาดปกติเริ่มต้น */
   revertDataToNormalSize(data, checkZoom) {
      if (checkZoom || this.countZoom > 0) {
         for (const i of data) {
            if (i.signItems) {
               for (const j of i.signItems) {
                  j.fieldWidth /= this.getCountZoom();
                  j.fieldHeight /= this.getCountZoom();
                  j.coordinateX /= this.getCountZoom();
                  j.coordinateY /= this.getCountZoom();
               }
            }
         }
      }
   }

   /** คำนวณว่ารูปที่วางลงนั้นหลุดออกนอกหรอบหรือไม่ */
   calculateOutBoundItem(e) {
      const target = $(e.target);
      const parentSvg = $(e.target.parentNode);
      const fieldType = target.attr('fieldType');
      let itemWidth, itemHeight;
      if (((fieldType === this._keyFieldType.text) || (fieldType === this._keyFieldType.image)) && (target.attr('ref')) != undefined) {
         itemWidth = parseFloat($(parentSvg.find('rect')[0]).attr('width'));
         itemHeight = parseFloat($(parentSvg.find('rect')[0]).attr('height'));
      } else {
         itemWidth = parseFloat(target.attr('width'));
         itemHeight = parseFloat(target.attr('height'));
      }
      const xItem = parseFloat(target.attr('x')), yItem = parseFloat(target.attr('y'));
      const imgWidth = this._imgFocusCal.width.baseVal.value, imgHeight = this._imgFocusCal.height.baseVal.value;
      let calShiftXitem;
      let calShiftYitem;
      let calXitem;
      let calYitem;
      if (fieldType === this._keyFieldType.signature || fieldType === this._keyFieldType.initSignature) {
         calShiftXitem = imgWidth - itemWidth; // เมื่อลากลายเซ็นต์นอกขอบขวาของกระดาษต้องขยับความกว้างของลายเซ็นต์ออกมาจากขอบกระดาษ
         calShiftYitem = imgHeight - itemHeight;
         calXitem = xItem + itemWidth;
         calYitem = yItem + itemHeight;
         if (xItem < 0) {
            $(e.target).attr('x', 0);
         } else if (calXitem > imgWidth) {
            $(e.target).attr('x', calShiftXitem);
         }

         if (yItem < 0) {
            $(e.target).attr('y', 0);
         } else if (calYitem > imgHeight) {
            $(e.target).attr('y', calShiftYitem);
         }
      } else if (fieldType === this._keyFieldType.name || fieldType === this._keyFieldType.date || fieldType === this._keyFieldType.text || fieldType === this._keyFieldType.image) {
         // เมื่อลากลายเซ็นต์นอกขอบขวาของกระดาษต้องขยับความกว้างของลายเซ็นต์ออกมาจากขอบกระดาษ
         if (fieldType === this._keyFieldType.text) {
            calShiftXitem = imgWidth - itemWidth;
            calShiftYitem = imgHeight - itemHeight;
            calXitem = xItem + itemWidth;
            calYitem = yItem + itemHeight;
         } else {
            calShiftXitem = imgWidth - (itemWidth * this.getCountZoom());
            calShiftYitem = imgHeight - (itemHeight * this.getCountZoom());
            calXitem = xItem + (itemWidth * this.getCountZoom());
            calYitem = yItem + (itemHeight * this.getCountZoom());
         }
         if (xItem < 0) {
            $(e.target).attr('x', 0);
            $($(e.target).children()[0]).attr('x', 0);
         } else if (calXitem > imgWidth) {
            $(e.target).attr('x', calShiftXitem);
            $($(e.target).children()[0]).attr('x', calShiftXitem);
         }

         if (yItem < 0) {
            $(e.target).attr('y', 0);
         } else if (calYitem > imgHeight) {
            $(e.target).attr('y', calShiftYitem);
         }
      }
   }

   /** คำนวณว่ารูปที่วางลงนั้นหลุดออกนอกหรอบหรือไม่กรณี Image Tag g */
   calculateOutBoundItemImage(e) {
      const target = $(e.target);
      const fieldType = target.attr('fieldType');
      let itemWidth, itemHeight, xItem, yItem, imgWidth, imgHeight, calShiftXitem, calShiftYitem, calXitem, calYitem;
      if (fieldType === this._keyFieldType.image) { /// เช็คเงื่อนไข Type Image ที่ถูก brwose file เรียบร้อย
         itemWidth = target.attr('width') ? parseFloat(target.attr('width')) : 0;
         itemHeight = target.attr('height') ? parseFloat(target.attr('height')) : 0;
         xItem = parseFloat(target.attr('x')), yItem = parseFloat(target.attr('y'));
         imgWidth = this._imgFocusCal.width ? this._imgFocusCal.width.baseVal.value : 0;
         imgHeight = this._imgFocusCal.height ? this._imgFocusCal.height.baseVal.value : 0;
         calShiftXitem = imgWidth - itemWidth;
         calShiftYitem = imgHeight - itemHeight;
         calXitem = xItem + itemWidth;
         calYitem = yItem + itemHeight;
         if (xItem < 0) {
            $(e.target).attr('x', 0);
            $($(e.target).children()[0]).attr('x', 0);
         } else if (calXitem > imgWidth) {
            $(e.target).attr('x', calShiftXitem);
            $($(e.target).children()[0]).attr('x', calShiftXitem);
         }

         if (yItem < 0) {
            $(e.target).attr('y', 0);
         } else if (calYitem > imgHeight) {
            $(e.target).attr('y', calShiftYitem);
         }
      } else { // เงื่อนไข checkbox ใช้ Tag G & Rect
         itemWidth = parseFloat($(e.target).find('rect').width());
         itemHeight = parseFloat($(e.target).find('rect').height());
         const transforms = this.getValueTransform(target.attr('transform'));
         xItem = parseFloat(transforms[4]), yItem = parseFloat(transforms[5]);
         imgWidth = parseFloat($($(target.parent()[0]).parent()).children().width());
         imgHeight = parseFloat($($(target.parent()[0]).parent()).children().height());
         const transform = Math.abs(this.getValueTransform('rotate(0,0,0)')[0]);
         let widthReal = 0, heightReal = 0;
         switch (transform) {
            case 0:
               widthReal = imgWidth;
               heightReal = imgHeight;
               break;
            case 90:
               widthReal = imgHeight;
               heightReal = imgWidth;
               break;
            case 180:
               widthReal = imgWidth;
               heightReal = imgHeight;
               break;
            case 270:
               widthReal = imgHeight;
               heightReal = imgWidth;
               break;
            default:
               widthReal = imgWidth;
               heightReal = imgHeight;
               break;
         }
          calShiftXitem = widthReal - itemWidth; // เมื่อลากลายเซ็นต์นอกขอบขวาของกระดาษต้องขยับความกว้างของลายเซ็นต์ออกมาจากขอบกระดาษ
          calShiftYitem = heightReal - itemHeight;
          calXitem = xItem + itemWidth;
          calYitem = yItem + itemHeight;
          if (xItem < 0) {
            if (yItem < 0) {
               yItem = 0;
            } else if (yItem + itemHeight > heightReal) {
               yItem = calShiftYitem;
            }
            this.setPositionCurrentSignItemImage($(e.target), 0, yItem);
         } else if (calXitem > widthReal) {
            if (yItem < 0) {
               yItem = 0;
            } else if (yItem + itemHeight > heightReal) {
               yItem = calShiftYitem;
            }
            this.setPositionCurrentSignItemImage($(e.target), calShiftXitem, yItem);
         } else if (yItem < 0) {
            if (xItem < 0) {
               xItem = 0;
            } else if (xItem + itemWidth > widthReal) {
               xItem = calShiftXitem;
            }
            this.setPositionCurrentSignItemImage($(e.target), xItem, 0);
         } else if (calYitem > heightReal) {
            if (xItem < 0) {
               xItem = 0;
            } else if (xItem + itemWidth > widthReal) {
               xItem = calShiftXitem;
            }
            this.setPositionCurrentSignItemImage($(e.target), xItem, calShiftYitem);
         }
      }
   }

   setPositionCurrentSignItemImage(groupSignItem, coordinateX, coordinateY) {
      const matrix = 'matrix(1,0,0,1,' + coordinateX + ',' + coordinateY + ')';
      groupSignItem.attr('transform', matrix);
   }

   generateTextControl(objText: any, defaultText: any) {
      const that = this;
      objText.node.addEventListener('dblclick', function (e) {
         let parentId = e.target.parentNode.id;
         const textId = parentId;
         let svgId = parentId;
         if (e.target.parentNode.nodeName === 'text') {
            svgId = e.target.parentNode.parentNode.id;
            const textChildren = e.target.parentNode.parentNode.childNodes;
            for (let i = 0; i < textChildren.length; i++) {
               const contrlText = <HTMLImageElement>textChildren[i];
               if (textChildren[i].nodeName === 'g'
                  && contrlText.getAttribute('class') !== 'signature' && contrlText.getAttribute('class') !== 'initSignature' && contrlText.getAttribute('class') !== 'image' && contrlText.getAttribute('class') !== 'checkbox') {
                  parentId = contrlText.id;
                  break;
               }
            }
         }

         const txtEle = document.getElementById(textId);
         const ele = document.getElementById(parentId);
         let parentWidth = ele.getBoundingClientRect().width;
         const parentHeight = ele.getBoundingClientRect().height;
         const transformValue = ele.getAttribute('transform');
         const eleValue = txtEle.textContent;
         const calWidth = calculateLenStrSign(eleValue);
         if (calWidth > parentWidth) {
            parentWidth = calWidth;
         }

         const children = ele.parentNode.parentNode.childNodes;
         let pageWidth, maxWidth;
         const coX = transformValue.split(',')[4];
         for (let i = 0; i < children.length; i++) {
            if (children[i].nodeName === 'image') {
               pageWidth = (<HTMLImageElement>children[i]).getBoundingClientRect().width;
               break;
            }
         }
         maxWidth = pageWidth - parseInt(coX, 10);
         const fo = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
         fo.setAttribute('id', 'svg-' + parentId);
         fo.setAttribute('width', String(parentWidth));
         fo.setAttribute('height', String(parentHeight));
         fo.style.maxWidth = maxWidth + 'px';
         fo.setAttribute('transform', transformValue);

         const fontSize = txtEle.getAttribute('font-size');
         const ratioZoom = parseInt(fontSize, 10) /  Number(fontSize);
         const ta = document.createElementNS('http://www.w3.org/1999/xhtml', 'input');
         ta.setAttribute('id', 'txt-' + parentId);
         ta.setAttribute('type', 'text');
         ta.setAttribute('maxlength', String(150));
         ta.setAttribute('placeholder', defaultText);
         ta.style.fontSize = fontSize + 'px';
         ta.style.resize = 'none';
         ta.style.width = parentWidth + 'px';
         ta.style.maxWidth = maxWidth + 'px';
         ta.style.height = parentHeight + 'px';
         ta.style.background = 'white';
         if (!(eleValue === 'Input Text' || eleValue === 'กรอกข้อความ' || eleValue === '')) {
            ta.setAttribute('value', eleValue);
         }

         function  calculateLenStrSign(str) {
            const widthChar = 6;
            let len = 0;
            for (let i = 0; i < str.length; i++) {
               if ((str[i] === 'ำ' || str[i] === 'ณ' || str[i] === 'ฏ' || str[i] === 'ฐ')) {
                  len += 6.3;
               } else if ((str[i] >= 'a' && str[i] <= 'z') || (str[i] >= 'A' && str[i] <= 'Z') || (str[i] >= '0' && str[i] <= '9')
                  || (str[i] === '/') || (str[i] >= 'ก' && str[i] <= 'ฮ') || (str[i] >= 'เ' && str[i] <= 'ๆ') || (str[i] === 'ะ')
                  || (str[i] === ' ') || str[i] >= 'า' && str[i] <= 'ำ') {
                  len += widthChar;
               }
            }
            return len;
         }

         ta.addEventListener('input', function () {
            const w = calculateLenStrSign((<HTMLInputElement>this).value) * ratioZoom;
            if (w > parentWidth && w <= maxWidth) {
               this.style.width = w + 'px';
               fo.style.width = this.style.width;
            }
         });

         ta.addEventListener('keyup', function (evt) {
            const inputEle = <HTMLInputElement>this;
            if (evt.ctrlKey) {
               if (evt.key === 'a' || evt.key === 'A') {
                  inputEle.setSelectionRange(0, inputEle.value.length);
               }
            }
         });

         ta.addEventListener('keydown', function (evt) {
            const inputEle = <HTMLInputElement>this;
            const w = calculateLenStrSign(inputEle.value) * ratioZoom;
            if (evt.metaKey && (evt.key === 'a' || evt.key === 'A')) {
               inputEle.setSelectionRange(0, inputEle.value.length);
            } else if (['Enter', 'Escape'].includes(evt.key)) {
               this.blur();
               return false;
            } else if (w > maxWidth
               && !(evt.key === 'Backspace' || evt.key === 'Delete'
                  || evt.key === 'ArrowRight' || evt.key === 'ArrowLeft')) {
               // to cancel the event:
               if (evt.preventDefault) {
                  evt.preventDefault();
               }
               return false;
            }
         });

         $(ta).on('focusout', () => {
            const txtCtrl = document.getElementById('txt-' + parentId);
            let txtValue = (<HTMLInputElement>txtCtrl).value;

            if (txtValue === '') {
               txtValue = defaultText;
            }
            document.querySelector('svg [id="' + textId + '"]').closest('text').
            querySelector('tspan').textContent = txtValue;

            document.getElementById(svgId).removeChild(fo);
         });

         $(ta).on('click', () => {
            that.setVisibleProperty(true);
         });

         $(ta).on('select', () => {
            that.setVisibleProperty(true);
         });

         fo.appendChild(ta);
         document.getElementById(svgId).appendChild(fo);
         ta.focus();
         const controlTextbox = <HTMLInputElement>ta;
         const textValueLen = controlTextbox.value.length;
         controlTextbox.setSelectionRange(textValueLen, textValueLen);
         e.preventDefault();
      });
   }

   /** สร้าง check box */
   renderCheckBox(item, checkbox, flag, yMarginSign?) {
      const that = this;
      let pageNo, img, fieldType, pageType, positionType, idSignItem, y, newX, x, chkName, chkDate, certId, content, comment, idImageItem,
         fontStyle, fontSize, fontColor, fontBold, fontItalic, fontUnderline, textRequired,flagCheckbox;
      flagCheckbox = ($(item.node).attr('flagCheckbox')  === 'true');
      if (flagCheckbox) {
         $(flag.node).attr('style', 'visibility: visible');
      } else {
         $(flag.node).attr('style', 'visibility: hidden');
      }

      const fnClickCheckbox = (e) => {
         flagCheckbox = !flagCheckbox;
         if (flagCheckbox) {
            $(flag.node).attr('style', 'visibility: visible');
         } else {
            $(flag.node).attr('style', 'visibility: hidden');
         }
         $(item.node).attr('flagCheckbox', flagCheckbox);
         pageNo = $(item.node).attr('pageNum');
         pageType = $(item.node).attr('pageType');
         positionType = $(item.node).attr('positionType');
         chkName = ($(item.node).attr('chkName') === 'true');
         chkDate = ($(item.node).attr('chkDate') === 'true');
         certId = parseInt($(item.node).attr('certId'), 10);
         idSignItem = $(item.node).attr('id');
         if (yMarginSign) {
            y = item.y() + yMarginSign;
         } else {
            y = item.y();
         }
         switch (item.type) {
            case 'image' :
               if ($(item.node).attr('fieldType')  === 'initSignature') {
                  fieldType = 'initSignature';
               } else if ($(item.node).attr('fieldType')  === 'signature') {
                  fieldType = 'signature';
               } else if ($(item.node).attr('fieldType')  === 'image') {
                  fieldType = 'image';
               }
            case 'text':
               fieldType = $(item.node).attr('class');
               break;
            default:
               break;
         }
         newX = item.attr('newX');
         x = item.x();
         that._signer = $(item.node).attr('signer');
         fieldType = $(item.node).attr('class');
         content = '';
         if (fieldType === 'text') {
            content = item.node.textContent;
            fontStyle = $(item.node).attr('fontStyle');
            fontSize = Number($(item.node).attr('fontSize'));
            fontColor = $(item.node).attr('fontColor');
            fontBold = ($(item.node).attr('fontBold') === 'true');
            fontItalic = ($(item.node).attr('fontItalic') === 'true');
            fontUnderline = ($(item.node).attr('fontUnderline') === 'true');
            textRequired = ($(item.node).attr('textRequired') === 'true');
         } else if (fieldType === 'comment') {
            comment =  $(item.node).attr('comment') ? JSON.parse($(item.node).attr('comment')) : null;
         } else if (fieldType === 'image') {
            idImageItem = $(item.node).attr('ref');
         }
         that.setSignItem(this._signer
            , fieldType
            , pageType
            , pageNo
            , positionType
            , chkName
            , chkDate
            , item.x()
            , y
            , item.width()
            , item.height()
            , idSignItem
            , item.attr('order')
            , content
            , false
            , idImageItem
            , fontStyle
            , fontSize
            , fontColor
            , fontBold
            , fontItalic
            , fontUnderline
            , textRequired
            , flagCheckbox
         );
         if (that.taskAttribute.docList[that.currentIndex].signItems) {
            for (let i = 0; i < that.taskAttribute.docList[that.currentIndex].signItems.length; i++) {
               if (that.taskAttribute.docList[that.currentIndex].signItems[i].idSignItem === idSignItem) {
                  that.taskAttribute.docList[that.currentIndex].signItems[i] = that._signItem;
                  break;
               }
            }
         }
         e.preventDefault();
      }
      checkbox.node.addEventListener('click', function (e) {
         fnClickCheckbox(e);
      });

      flag.node.addEventListener('click', function (e) {
         fnClickCheckbox(e);
      });
   }

   setTextStyle() {
      const ratioZoom = this.getCountZoom();
      if (this._objDraw) {
         this.fontDetail.fontStyle = this._objDraw.attr('fontStyle');
         this.fontDetail.fontSize = Number(this._objDraw.attr('fontSize'));
         this.fontDetail.fontColor = this._objDraw.attr('fontColor');
         this.fontDetail.fontBold = (this._objDraw.attr('fontBold')  === 'true');
         this.fontDetail.fontItalic = (this._objDraw.attr('fontItalic') === 'true');
         this.fontDetail.fontUnderline = (this._objDraw.attr('fontUnderline') === 'true');
         this.fontDetail.textRequired = (this._objDraw.attr('textRequired') === 'true');
      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         this.fontDetail.fontStyle = $objectDrag.attr('fontStyle');
         this.fontDetail.fontSize = Number($objectDrag.attr('fontSize'));
         this.fontDetail.fontColor = $objectDrag.attr('fontColor');
         this.fontDetail.fontBold = ($objectDrag.attr('fontBold') === 'true');
         this.fontDetail.fontItalic = ($objectDrag.attr('fontItalic') === 'true');
         this.fontDetail.fontUnderline = ($objectDrag.attr('fontUnderline') === 'true');
         this.fontDetail.textRequired = ($objectDrag.attr('textRequired') === 'true');

      }
      this.setFontDetail();
   }

   setFontDetail(isChangeFont?) {
      let objId;
      const ratioZoom = this.getCountZoom();
      if (this._objDraw) {
         objId = this._objDraw.attr('id');

      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         objId = $objectDrag.attr('id');
      }

      const objElement = document.getElementById(objId);
      for (let i = 0; i < objElement.getElementsByTagName('tspan').length; i++) {
         if (isChangeFont) {
            /** โหลด font เพื่อไม่ให้แสดงตัวอักษรแล้วกระพริบ */
            if (objElement.getElementsByTagName('text')[i]) {
               let o = $('#' + objElement.getElementsByTagName('tspan')[i].id).clone();
               o.attr('id', o.attr('id') + 'tmp');
               o[0].style.fontFamily = this.fontDetail.fontStyle;
               o[0].style.visibility = 'hidden';
               $('#' + objElement.getElementsByTagName('text')[i].id).append(o);
               setTimeout(() => {
                  o.remove();
                  objElement.getElementsByTagName('tspan')[i].style.fontFamily = this.fontDetail.fontStyle;
               },350);
            }
            isChangeFont = false;
         } else {
            objElement.getElementsByTagName('tspan')[i].style.fontFamily = this.fontDetail.fontStyle;
         }
         objElement.getElementsByTagName('tspan')[i].style.fontSize = (this.fontDetail.fontSize * ratioZoom) + 'px';
         objElement.getElementsByTagName('tspan')[i].style.fill = this.fontDetail.fontColor;
         if (this.fontDetail.fontItalic) {
            objElement.getElementsByTagName('tspan')[i].style.fontStyle = 'italic';
         } else {
            objElement.getElementsByTagName('tspan')[i].style.fontStyle = 'normal';
         }

         if (this.fontDetail.fontUnderline) {
            objElement.getElementsByTagName('tspan')[i].style.textDecoration = 'underline';
         } else {
            objElement.getElementsByTagName('tspan')[i].style.textDecoration = 'none';
         }

         if (this.fontDetail.fontBold) {
            objElement.getElementsByTagName('tspan')[i].style.fontWeight = 'bold';
         } else {
            objElement.getElementsByTagName('tspan')[i].style.fontWeight = 'normal';
         }
      }
   }

   onFontDetailTypeChange(value) {
      if (this._objDraw) {
         this._objDraw.attr('fontStyle', value.fontStyle);
         this._objDraw.attr('fontSize', value.fontSize);
         this._objDraw.attr('fontColor', value.fontColor);
         this._objDraw.attr('fontBold', value.fontBold);
         this._objDraw.attr('fontItalic', value.fontItalic);
         this._objDraw.attr('fontUnderline', value.fontUnderline);
         this._objDraw.attr('textRequired', value.textRequired);

      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         $objectDrag.attr('fontStyle', value.fontStyle);
         $objectDrag.attr('fontSize', value.fontSize);
         $objectDrag.attr('fontColor', value.fontColor);
         $objectDrag.attr('fontBold', value.fontBold);
         $objectDrag.attr('fontItalic', value.fontItalic);
         $objectDrag.attr('fontUnderline', value.fontUnderline);
         $objectDrag.attr('textRequired', value.textRequired);
      }
      if (this.taskAttribute.docList[this.currentIndex].signItems) {
         for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
            if (this._idSignitems === item.idSignItem) {
               item.fontStyle = value.fontStyle;
               item.fontSize = value.fontSize;
               item.fontColor = value.fontColor;
               item.fontBold = value.fontBold;
               item.fontItalic = value.fontItalic;
               item.fontUnderline = value.fontUnderline;
               item.textRequired = value.textRequired;
            }
         }
      }
      this.setFontDetail(true);
   }

   editSignature(img,chkName,chkDate){
      let imgTmp = new Image();
      imgTmp.crossOrigin="anonymous"
      let width = 0;
      imgTmp.onload = () => {
         if (chkName || chkDate) {
            width = 50;
            let canvas = this.canvasOriginal.nativeElement;
            let context = canvas.getContext("2d");
            var hRatio = canvas.width / imgTmp.width;
            var vRatio = canvas.height / imgTmp.height;
            var ratio = Math.min(hRatio, vRatio);
            var centerShiftX = ( canvas.width - imgTmp.width*ratio ) / 2;
            var centerShiftY = ( canvas.height - imgTmp.height*ratio ) / 2;
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.drawImage(imgTmp,0,0, imgTmp.width+width, imgTmp.height, centerShiftX, centerShiftY,
               (imgTmp.width+width) * ratio, imgTmp.height * ratio);
            const tmp = this.editPatternCanvas(this.canvasOriginal.nativeElement, 'original',chkName,chkDate);
            img.attr('href', tmp.toDataURL());
         } else {
            img.attr('href', imgTmp.src);
         }
      }
      imgTmp.src = this.picSign;
   }

   editPatternCanvas(oldCanvas: HTMLCanvasElement , type: string,chkName,chkDate) {
      let canvasTmp = this.canvasPatternTmp.nativeElement;
      const ctx = canvasTmp.getContext('2d');
      ctx.clearRect(0, 0, canvasTmp.width, canvasTmp.height);

      if ((chkName || chkDate) && type !== 'init') {
         canvasTmp.width = oldCanvas.width + 75;
         canvasTmp.height = oldCanvas.height;

         ctx.drawImage(oldCanvas, -10, 0);

         const datepipe: DatePipe = new DatePipe('en-US');
         const formatDate = datepipe.transform(this.currentDate, 'dd/MM/yyyy');
         const formatTime = datepipe.transform(this.currentDate,  'HH:mm:ss Z');

         ctx.font = '200 8px Arial';
         const width = ctx.measureText(formatDate + ' ' + formatTime).width - 10;

         const x = canvasTmp.width - width;
         let y = canvasTmp.height / 2;
         if (chkName && chkDate) {
            y -= 10;
         }

         const lineSpace = 8;

         this.fillIncludeText(ctx,chkName,chkDate, x, y, lineSpace, formatDate, formatTime);
      } else {
         canvasTmp.width = oldCanvas.width;
         canvasTmp.height = oldCanvas.height;
         ctx.drawImage(oldCanvas, 0, 0);
      }
      return canvasTmp;
  }

  fillIncludeText(ctx: any,chkName: boolean,chkDate: boolean, x: number, y: number, lineSpace: number, date: string, time: string) {
      const user = JSON.parse(localStorage.getItem('idex-user'));
      if (chkName) {
         ctx.fillText('Digital signed by', x, y);
         y = y + lineSpace;
         let limit = 19;
         if (user.name.length <= limit) {
            ctx.fillText(user.name, x, y);
            y = y + lineSpace;
         } else {
            let len = user.name.length;
            let startIndex = 0;
            let endIndex = len - 1;
            while(startIndex <= endIndex){
               let str = user.name.substring(startIndex,startIndex + limit);
               startIndex += limit;
               ctx.fillText(str, x, y);
               y = y + lineSpace;
            }
         }
      }
      if (chkDate) {
         ctx.fillText('Date: ' + date, x, y);
         y = y +  lineSpace;
         ctx.fillText(time, x, y);
      }
   }

}
